import React from "react";
import { Redirect } from "react-router-dom";
// import Cookies from "js-cookie";
import {
  Breadcrumb,
  Card,
  Row,
  Col,
  // Avatar,
  Form,
  Input,
  // Button,
  // Space,
  Select,
  // DatePicker,
  message,
  Alert,
  Spin,
  Modal,
  // Skeleton,
  Table,
  Tag,
  Divider,
  Typography,
  Empty,
} from "antd";
import {
  // DiffOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DollarOutlined,
  // BarcodeOutlined,
  // UserAddOutlined,
  UserOutlined,
  // CloseSquareOutlined,
  ExclamationCircleOutlined,
  CarOutlined,
  UserSwitchOutlined,
  EyeOutlined,
  IdcardOutlined,
  CalendarOutlined,
  TeamOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import moment from "moment";
// import NumberFormat from "react-number-format";

// import axios from "axios";
import Config from "../../Config";

import { connect } from "react-redux";
import {
  initHandler,
  ajaxViewHandler,
  ajaxHandler,
  setConfig,
  extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import { RoundedInput, RoundedButton, RoundedSelect, RoundedDatePicker  } from '../../components/RoundedComponents';
import ErrorAlertModal from '../../components/ErrorAlertModal';

// const FormItem = Form.Item;

// const tailFormItemLayout = {
//   wrapperCol: {
//     xs: {
//       span: 24,
//       offset: 0,
//     },
//     sm: {
//       span: 19,
//       offset: 5,
//     },
//     lg: {
//       span: 19,
//       offset: 5,
//     },
//   },
// };

// const layout = {
//   labelCol: { span: 5 },
//   wrapperCol: { span: 19 },
// };
// const tailLayout = {
//   wrapperCol: { offset: 8, span: 16 },
// };

const configClass = {
  title: "Pendaftaran dari ERI",
  apiUrl: {
    kabupaten: "master/api/kabupaten/",
    kecamatan: "master/api/kecamatan/",
    desa: "master/api/desa/",
    kepemilikan: "master/api/kepemilikan/",
    fungsi: "master/api/fungsi/",
    jenis_kendaraan: "master/api/jenis/kendaraan/",
    merek: "master/api/merek/",
    tipe: "master/api/tipe/",
    bahan_bakar: "master/api/bahan/bakar/",
    warna_plat: "master/api/plat",
    pemilik: "pemilik/api/wajib/pajak/",
    kendaraan: "kendaraan/api/kendaraan-eri/",
    jenis_layanan: "master/api/layanan/data-eri/",
    history: "kendaraan/api/history/",
    history_kendaraan: "kendaraan/api/history-kendaraan/",
    golongan: "master/api/golongan/",
    penetapan: "transaksi/api/tagihan/",
  },
  pageUrl: {
    cetak_no: "/addon/cetak_antrian/",
    redirect_url: "/admin/transaksi/penetapan-biaya-eri/"
  },
  breadCrumb: [
    <span>
      <CarOutlined /> transaksi
    </span>,
    "pendaftaran dari ERI",
  ],
};

const config = new Config();
const { Text } = Typography;

const STATUS_TAG_COLORS = {
  'Pendaftaran': { bg: '#fffbe6', border: '#ffe58f', color: '#ad6800' },
  'Penetapan':   { bg: '#e6f0fb', border: '#91b4e8', color: '#1e4d8a' },
  'Pembayaran':  { bg: '#f6ffed', border: '#b7eb8f', color: '#389e0d' },
};

class FormPendaftaran extends React.Component {
  formRef = React.createRef();
  formRefScroll = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      isMobile: window.innerWidth <= 768,
      errComponent: false,
      errTitle: "",
      errMsg: "",

      isSukses: false,
      redirect_nopol: "",

      loadingButton: false,

      isModalRiwayat: false,
      modalBatalUptLain: false,
      batalUptLainData: null,
      batalUptLainNoPol: '',
      batalAlasan: '',
      batalKeterangan: '',
      loadingBatalUptLain: false,

      loadingKabupaten: null,
      listKabupaten: [],

      kabupatenDipilih: null,

      loadingKecamatan: null,
      listKecamatan: [],

      loadingDesa: null,
      listDesa: [],

      loadingKepemilikan: null,
      listKepemilikan: [],

      loadingFungsi: null,
      listFungsi: [],

      loadingJenisKendaraan: false,
      listJenisKendaraan: [],

      loadingMerek: false,
      listMerek: [],

      loadingTipe: false,
      listTipe: [],

      loadingGolongan: false,
      listGolongan: [],

      loadingBahanBakar: false,
      listBahanBakar: [],

      loadingWarnaPlat: false,
      listWarnaPlat: [],

      loadingJenisLayanan: false,
      listJenisLayanan: [],
      listJenisLayananRequirement: [],

      cari_no_pol: undefined,

      isOpenForm: false,

      loadingDataKendaraan: false,
      dataKendaraan: null,
      bolehEditTanggalPajak: true,

      modalMasaPajakAktif: false,
      masaPajakAktifMsg: "",

      modalNjkbKosong: false,
      pendingSubmitValues: null,
      loadingCekNjkb: false,
      njkbPreview: null,
      loadingNjkbPreview: false,

      pemilik_lama: null,

      merek_dipilih: "",
      jenis_kendaraan_dipilih: "",

      jenis: "Kendaraan Lama",

      aksi: "tambah",
      method: "post",
      idLama: "",

      modalBaru: false,

      field_requirements: {},

      kabupaten_dipilih: "",
      kecamatan_dipilih: "",

      modalKonfirmasi: false,

      // modal "Mutasi Terdeteksi" (blocking) dihapus, diganti banner
      // non-blocking di body form - keputusan jalur (mutasi/rahasia/jual
      // beli) sekarang otomatis di backend saat submit, berdasarkan Jenis
      // Layanan yang dipilih staf (lihat diskusi 2026-10-11).
      mutasiInfo: null,
      pemilikEri: null,
      kendaraanEri: null,
      modalBandingKendaraan: false,

      modalBlock: false,

      errMsgRiwayat: '',
      searchText: "",
      loadingDataRiwayat: false,
      paginationRiwayat: { pageSize: 25 },
      dataSourceRiwayat: [],
      filterDataRiwayat: '',
      columnsRiwayat: [
        {
          title: 'NIK',
          width: 150,
          dataIndex: 'pemilik_nik',
          key: 'pemilik_nik',
        },
        {
          title: 'NAMA WP',
          width: 150,
          dataIndex: 'nama_wp',
          key: 'nama_wp',
        },
        {
          title: 'ALAMAT WP',
          width: 150,
          dataIndex: 'alamat_wp',
          key: 'alamat_wp'
        },
        {
          title: 'AKSI',
          width: 100,
          dataIndex: 'id',
          key: 'aksi',
          fixed: 'right',
          render: (value, row, index) => {
            return (
              <Row key={"space-aksi-" + index} justify="center">	<Col style={{ padding: 5 }}>
                <RoundedButton title="detail" className="btn-log" size="small" onClick={() => this.showDetail("DETAIL RIWAYAT PEMILIK", row, true)} shape="circle">
                  <EyeOutlined />
                </RoundedButton>
              </Col>
              </Row>
            )
          },
        }

      ],

      isModalTransaksiHistory: false,
      loadingTransaksiHistory: false,
      dataSourceTransaksiHistory: [],
      isModalDetailTransaksi: false,
      dataDetailTransaksi: null,
      columnsTransaksiHistory: [
        {
          title: 'Tgl Daftar',
          dataIndex: 'tgl_daftar',
          key: 'tgl_daftar',
          width: 140,
          render: val => val ? new Date(val).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) : '-',
        },
        {
          title: 'Nama',
          dataIndex: 'pemilik',
          key: 'nama',
          width: 160,
          render: val => val ? val.nama : '-',
        },
        {
          title: 'Status',
          dataIndex: 'status_label',
          key: 'status_label',
          width: 110,
          align: 'center',
          render: (val) => {
            const c = STATUS_TAG_COLORS[val] || { bg: '#f5f5f5', border: '#d9d9d9', color: '#595959' };
            return (
              <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: c.bg, borderColor: c.border, color: c.color, margin: 0 }}>
                {val || '-'}
              </Tag>
            );
          },
        },
        {
          title: 'Layanan',
          dataIndex: 'layanan',
          key: 'layanan',
          width: 180,
          render: val => Array.isArray(val) && val.length > 0
            ? val.map((item, idx) => (
              <Tag key={idx} style={{ borderRadius: 12, marginBottom: 2, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontSize: 11 }}>
                {item}
              </Tag>
            ))
            : <Text type="secondary">-</Text>,
        },
        {
          title: 'No Notice',
          dataIndex: 'no_notice',
          key: 'no_notice',
          width: 120,
          render: val => val
            ? <span style={{ fontFamily: 'monospace', fontWeight: 600, color: '#1e4d8a' }}>{val}</span>
            : <Text type="secondary">-</Text>,
        },
        {
          title: 'Masa Pajak',
          key: 'masa_pajak',
          width: 200,
          render: (_, row) => {
            const fmtSingkat = val => val ? new Date(val).toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' }) : '-';
            return <span style={{ fontSize: 12 }}>{fmtSingkat(row.masa_pajak_mulai)} &rarr; {fmtSingkat(row.masa_pajak_sampai)}</span>;
          },
        },
        {
          title: 'Total Bayar',
          dataIndex: 'total_bayar',
          key: 'total_bayar',
          width: 150,
          align: 'right',
          render: val => <Text strong style={{ color: '#389e0d' }}>Rp {val ? val.toLocaleString('id-ID') : '0'}</Text>,
        },
        {
          title: 'Tgl Bayar',
          dataIndex: 'paid_on',
          key: 'paid_on',
          width: 140,
          render: val => val ? new Date(val).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) : '-',
        },
        {
          title: 'UPT',
          dataIndex: 'upt',
          key: 'upt',
          width: 150,
          render: val => val ? val.nama : '-',
        },
        {
          title: 'Aksi',
          key: 'aksi',
          width: 70,
          fixed: 'right',
          align: 'center',
          render: (_, row) => (
            <RoundedButton
              title="Detail"
              size="small"
              shape="circle"
              type="primary"
              style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none' }}
              onClick={() => this.setState({ isModalDetailTransaksi: true, dataDetailTransaksi: row })}
            >
              <EyeOutlined />
            </RoundedButton>
          ),
        },
      ],
    };
  }

  UNSAFE_componentWillMount() {
    this.props.initHandler();
  }

  componentDidMount() {
    this.loadMasterList();
    // this.getDataRiwayat();
    this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
    window.addEventListener('resize', this._handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._handleResize);
    clearTimeout(this._njkbPreviewTimeout);
  }

  setGambar = (e) => {
    this.setState({
      gambar: e.target.files[0],
    });
  };

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  reset_nopol = () => {
    this.setState({
      cari_no_pol: undefined,
      isOpenForm: false,
    });
  };

  handleTableChange = async (pagination, filters, sorter) => {
    const newPagination = { ...this.state.paginationRiwayat };
    newPagination.pageSize = pagination.pageSize;
    this.setState({
      loadingData: true,
      paginationRiwayat: newPagination
    });
    if (newPagination.current == 1) {
      this.getDataRiwayat(newPagination.pageSize);
    } else {
      this.getDataRiwayat(newPagination.pageSize, (newPagination.current - 1) * newPagination.pageSize);
    }


  }

  async getDataRiwayat(
    limit = this.state.paginationRiwayat.pageSize,
    offset = 0,
    search = this.state.searchText
  ) {
    this.props
      .ajaxViewHandler(
        "get",
        configClass.apiUrl.history +
        "?kendaraan=" + this.state.dataKendaraan.id +
        "&limit=" +
        limit +
        "&offset=" +
        offset +
        "&search=" +
        search
      )
      .then((action) => {
        const { isSuccess, responseMsg: data } = extractResult(action);
        if (isSuccess) {
          const pagination = { ...this.state.paginationRiwayat };
          pagination.total = data.count;
          this.setState({
            dataSourceRiwayat: data.results,
            paginationRiwayat: pagination,
          });
        } else {
          const errTitle = "error get data";
          this.setState({
            errTitle: errTitle,
            errMsg: data,
          });
          message.error({ content: errTitle, duration: 2, key: "toast" });
        }
        this.setState({ loadingData: false });
      })
      .catch((response) => {
        console.log("gagal_get_preview", response);
        message.error({
          content: "gagal request data, coba lagi",
          duration: 2,
          key: "toast",
        });
        this.setState({ loadingData: false });
      });
  }

  async getDataTransaksiHistory() {
    const nopol = this.state.dataKendaraan && this.state.dataKendaraan.nomor_polisi
      ? this.state.dataKendaraan.nomor_polisi
      : null;
    if (!nopol) return;
    this.setState({ loadingTransaksiHistory: true });
    this.props
      .ajaxViewHandler(
        "get",
        configClass.apiUrl.history_kendaraan + "?nopol=" + nopol
      )
      .then((action) => {
        const { isSuccess, responseMsg: data } = extractResult(action);
        if (isSuccess) {
          this.setState({ dataSourceTransaksiHistory: Array.isArray(data) ? data : [] });
        } else {
          message.error({ content: "Gagal memuat riwayat transaksi", duration: 2, key: "toast" });
        }
        this.setState({ loadingTransaksiHistory: false });
      })
      .catch(() => {
        message.error({ content: "Gagal request riwayat transaksi", duration: 2, key: "toast" });
        this.setState({ loadingTransaksiHistory: false });
      });
  }

  renderTransaksiHistoryMobileCard = (row, idx) => {
    const fmtTglSingkat = val => val ? new Date(val).toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' }) : '-';
    return (
      <Card
        key={row.id || idx}
        style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{
          background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
          borderBottom: '1px solid #d0dff5',
          padding: '12px 16px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
        }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847', lineHeight: 1.3 }}>
              {row.pemilik ? row.pemilik.nama : '-'}
            </div>
            <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
              <CalendarOutlined style={{ marginRight: 4 }} />
              {fmtTglSingkat(row.tgl_daftar)}
            </div>
          </div>
          <RoundedButton
            title="Detail"
            size="small"
            shape="circle"
            type="primary"
            style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', flexShrink: 0 }}
            onClick={() => this.setState({ isModalDetailTransaksi: true, dataDetailTransaksi: row })}
          >
            <EyeOutlined />
          </RoundedButton>
        </div>
        <div style={{ padding: '10px 16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <Text type="secondary" style={{ fontSize: 12 }}>Status</Text>
            {(() => {
              const c = STATUS_TAG_COLORS[row.status_label] || { bg: '#f5f5f5', border: '#d9d9d9', color: '#595959' };
              return (
                <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: c.bg, borderColor: c.border, color: c.color, margin: 0 }}>
                  {row.status_label || '-'}
                </Tag>
              );
            })()}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <Text type="secondary" style={{ fontSize: 12 }}>Layanan</Text>
            <Text style={{ fontSize: 12, textAlign: 'right', maxWidth: '70%' }}>
              {Array.isArray(row.layanan) && row.layanan.length > 0 ? row.layanan.join(', ') : '-'}
            </Text>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <Text type="secondary" style={{ fontSize: 12 }}>No Notice</Text>
            <Text style={{ fontSize: 12, fontFamily: 'monospace', fontWeight: 600, color: '#1e4d8a' }}>{row.no_notice || '-'}</Text>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <Text type="secondary" style={{ fontSize: 12 }}>Tgl Bayar</Text>
            <Text style={{ fontSize: 12 }}>{fmtTglSingkat(row.paid_on)}</Text>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <Text type="secondary" style={{ fontSize: 12 }}>UPT</Text>
            <Text style={{ fontSize: 12 }}>{row.upt ? row.upt.nama : '-'}</Text>
          </div>
          <Divider style={{ margin: '8px 0' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text strong style={{ fontSize: 12 }}>Total Bayar</Text>
            <Text strong style={{ fontSize: 13, color: '#389e0d' }}>
              Rp {row.total_bayar ? row.total_bayar.toLocaleString('id-ID') : '0'}
            </Text>
          </div>
        </div>
      </Card>
    );
  };

  searchKendaraan = (no_polisi) => {
    this.setState({
      errComponent: false,
      errTitle: "",
      isOpenForm: false,
      loadingDataKendaraan: true,
    });

    message.loading({
      content: "Proses pencarian...",
      duration: 0,
      key: "toast",
    });

    this.props
    .ajaxViewHandler(
      "get",
      configClass.apiUrl.penetapan + "?nomor_polisi=KH" + no_polisi
    )
    .then((action) => {
      const { isSuccess, responseMsg: datas } = extractResult(action);
      if (isSuccess) {
        message.destroy();
        if (datas.results.length == 0) {
          this.props.ajaxViewHandler(
            "get",
            configClass.apiUrl.penetapan + "cek-upt-lain/?nomor_polisi=KH" + no_polisi
          ).then((cekAction) => {
            const { isSuccess: cekIsSuccess, responseMsg: cek } = extractResult(cekAction);
            if (cekIsSuccess) {
              if (cek.ada) {
                this.setState({
                  loadingDataKendaraan: false,
                  modalBatalUptLain: true,
                  batalUptLainData: cek,
                  batalUptLainNoPol: no_polisi,
                  batalAlasan: '',
                  batalKeterangan: '',
                });
              } else {
                this.setState({ loadingDataKendaraan: false });
                this.previewData(no_polisi);
              }
            } else {
              this.setState({ loadingDataKendaraan: false });
              this.previewData(no_polisi);
            }
          });
        } else {
          const data = datas.results[0];
          this.setState({
            errComponent: false,
            errTitle: "",
            modalKonfPenetapan: data.status == 1 ? true : false
          });
          window.location.href=configClass.pageUrl.redirect_url + "?no_pol=" + no_polisi;
          // return <Redirect to={configClass.pageUrl.redirect_url + "?no_pol=" + this.state.redirect_nopol} />;
        }
      }else{
        const errTitle = "error preview data lama";
          this.setState({
            loadingDataKendaraan: false,
            errTitle: errTitle,
            errMsg: datas,
          });
          message.error({ content: errTitle, duration: 2, key: "toast" });
      }
    });
  };

  cekPreview(stateName, compare_id, compare_nama, compareKeyDisplay = "") {
    // var chat_dipilih = this.props.chat_dipilih;
    // if(chat_dipilih[compare_id] != null && chat_dipilih[compare_nama] != null && this.state[stateName] != undefined && this.state[stateName].results != undefined){
    var tempList = this.state[stateName];
    var temp = tempList && Array.isArray(tempList.results)
      ? tempList.results
      : (Array.isArray(tempList) ? tempList : []);
    var res = false;
    // console.log('tempList', tempList);
    // console.log('temp', temp);
    // console.log('compare_id', compare_id);
    // console.log('data_kendaraan', this.state.dataKendaraan);
    // console.log('compare_id_val', this.state.dataKendaraan[compare_id]);

    temp.map(item => {
      // console.log(item.id, chat_dipilih.company);
      if (item.id == this.state.dataKendaraan[compare_id]) {
        // console.log(stateName);
        // console.log('ada');
        res = true;
      }
    });
    if (res == false) {
      // console.log(stateName)
      // console.log('sini')
      if (compareKeyDisplay == "") {
        // console.log('sini1')
        temp = [...temp, {
          id: this.state.dataKendaraan[compare_id],
          nama: this.state.dataKendaraan[compare_nama]
        }];
      } else {
        // console.log('sini2', compare_id + "#" + compare_nama + "#" + compareKeyDisplay)
        // console.log('temp_bf', temp)
        temp = [...temp, {
          id: this.state.dataKendaraan[compare_id],
          nama: this.state.dataKendaraan[compare_nama],
          kode: this.state.dataKendaraan[compareKeyDisplay],
        }];
        // console.log('temp_af', temp)
      }
      // console.log('temp_list', tempList.results)
      // console.log('temp_list2', temp)
      // console.log('temp_list3', temp)
      // console.log('temp', temp);
      this.setState({
        [stateName]: {
          count: tempList && tempList.count != undefined ? tempList.count : temp.length,
          previous: tempList && tempList.previous != undefined ? tempList.previous : null,
          next: tempList && tempList.next != undefined ? tempList.next : null,
          results: temp
        }
      }, () => {
        // console.log('temp_listf', this.state[stateName])
        // console.log([compare_nama], this.state.dataKendaraan[compare_id])
        if (stateName == "listTipessssssssssss") {
          this.formRef.current.setFieldsValue({
            [compare_id]: {
              // label: this.state.dataKendaraan[compare_id]+" - "+this.state.dataKendaraan[compare_nama],
              value: this.state.dataKendaraan[compare_id],
            },
          })
          this.formRef.current.setFieldsValue({
            koding: this.state.dataKendaraan.koding != undefined && this.state.dataKendaraan.koding != null && this.state.dataKendaraan.koding != "" ? this.state.dataKendaraan.koding : this.state.dataKendaraan.tipe_kode.replace(/ /g, ''),
          })
        } else {
          this.formRef.current.setFieldsValue({
            [compare_id]: this.state.dataKendaraan[compare_id],
          })
        }
      });
      // console.log('temp2', this.state.[stateName]);
    } else {
      // console.log(stateName);
      // console.log('sana')
      if (stateName == "listTipesssssssssssssss") {
        this.formRef.current.setFieldsValue({
          [compare_id]: {
            // label: this.state.dataKendaraan[compare_id]+" - "+this.state.dataKendaraan[compare_nama],
            value: this.state.dataKendaraan[compare_id],
          },
        })
        this.formRef.current.setFieldsValue({
          koding: this.state.dataKendaraan.koding != undefined && this.state.dataKendaraan.koding != null && this.state.dataKendaraan.koding != "" ? this.state.dataKendaraan.koding : this.state.dataKendaraan.tipe_kode.replace(/ /g, ''),
        })
      } else {
        this.formRef.current.setFieldsValue({
          [compare_id]: this.state.dataKendaraan[compare_id],
        })
      }
    }
    // }else{
    //   if(chat_dipilih[compare_id]==null){
    //     this.formRefAgen.current.setFieldsValue({
    //       [compare_id]: undefined,
    //     });
    //   }
    // }
  }

  async previewData(no_polisi) {
    message.loading({
      content: "Proses pencarian...",
      duration: 0,
      key: "toast",
    });

    this.props
      .ajaxViewHandler(
        "get",
        configClass.apiUrl.kendaraan + "?nomor_polisi=KH" + no_polisi
      )
      .then((action) => {
        const { isSuccess, responseMsg: datas } = extractResult(action);
        // Baca payload mentah dulu - extractResult() membuang semua field
        // selain `results` begitu response punya key itu (lihat
        // store/actions.js), jadi mutasi_terdeteksi/pemilik_eri & field
        // pasangannya tidak pernah sampai ke `datas` kalau dibaca lewat
        // extractResult (lihat diskusi 2026-10-10).
        const rawData = action && action.payload && action.payload.data;
        if (isSuccess) {
          if (datas.results.length == 0) {
            this.setState({
              isOpenForm: false,
              mutasiInfo: null,
              pemilikEri: null,
              kendaraanEri: null,
            });
            message.error({ content: "nomor kendaraan tidak ditemukan", duration: 2, key: "toast" });
          } else {
            this.setState({
              isOpenForm: true,
            }, () => {
              this.formRefScroll.current.scrollTo(0, 0);
            });
            const data = datas.results[0];
            //this.formRef.current.setFieldsValue(data);
            // API mengembalikan field ini sebagai "tanggal_pembayaran_terakhir",
            // sedangkan Form.Item di sini bernama "tanggal_pembayaran" - di-set
            // eksplisit di sini (bukan lewat loop generik per-key di bawah,
            // yang menulis balik ke nama key yang sama dengan sumbernya)
            // dan wajib dikosongkan kalau null supaya tidak ikut nilai
            // kendaraan yang dicari sebelumnya.
            if (data.tanggal_pembayaran_terakhir != null) {
              this.formRef.current.setFieldsValue({
                tanggal_pembayaran_picker: moment(data.tanggal_pembayaran_terakhir),
                tanggal_pembayaran: moment(data.tanggal_pembayaran_terakhir).format("DD-MM-YYYY"),
              });
            } else {
              this.formRef.current.setFieldsValue({
                tanggal_pembayaran_picker: undefined,
                tanggal_pembayaran: undefined,
              });
            }
            this.setState({
              pemilik_lama: data.pemilik,
              dataKendaraan: data,
              merek_dipilih: data.merek,
              jenis_kendaraan_dipilih: data.jenis_kendaraan,
              // kabupaten_wp/kecamatan_wp (bukan data.kabupaten/kecamatan
              // mentah) - itu snapshot Kendaraan SAAT pendaftaran, tidak
              // ikut sinkron kalau identitas pemilik dikoreksi belakangan
              // lewat kendaraan_riwayatidentitaspemilik. Lihat diskusi
              // sinkron desa/kecamatan/kabupaten 2026-10-14.
              kabupaten_dipilih: data.kabupaten_wp,
              kecamatan_dipilih: data.kecamatan_wp,
              // Popup konfirmasi "Sudah masuk H-90..." dinonaktifkan dulu
              // khusus di menu Pendaftaran dari ERI (sengaja selalu false,
              // bukan dihapus - gampang diaktifkan lagi kalau diminta).
              modalKonfirmasi: false,
              bolehEditTanggalPajak: data.tunggakan.boleh_edit_tanggal != undefined ? data.tunggakan.boleh_edit_tanggal : true,
              mutasiInfo: rawData && rawData.mutasi_terdeteksi ? {
                nopol_lama: rawData.nopol_lama,
                pemilik_lama: rawData.pemilik_lama,
              } : null,
              pemilikEri: (rawData && rawData.pemilik_eri) || null,
              kendaraanEri: (rawData && rawData.kendaraan_eri) || null,
            }, () => {
              const rule = {
                destination: {
                  stateProgressName: "loadingTipe",
                  endPoint: configClass.apiUrl.tipe + "?merek=" + this.state.merek_dipilih + "&jenis=" + this.state.jenis_kendaraan_dipilih,
                  stateDestination: "listTipe",
                },
                nextDestination: null,
              };
              this.getMasterList(rule);

              if (this.state.jenis_kendaraan_dipilih) {
                const ruleMerek = {
                  destination: {
                    stateProgressName: "loadingMerek",
                    endPoint: configClass.apiUrl.merek + "?jenis=" + this.state.jenis_kendaraan_dipilih,
                    stateDestination: "listMerek",
                  },
                  nextDestination: null,
                };
                this.getMasterList(ruleMerek);
              }

            });
            this.fetchNjkbPreview(data.tipe, data.tahun_buat);
            if (data.layanan_list != undefined) {
              data.layanan_list.map((item, idx) => {
                if (item.field_requirements != undefined && Object.keys(item.field_requirements).length > 0) {
                  let tempReq = this.state.field_requirements;
                  tempReq = { ...item.field_requirements };
                  this.setState({
                    field_requirements: tempReq
                  })
                }
              });
            }
            for (var key in data) {
              // "tanggal_pembayaran" mentah dari model dilewati di sini -
              // sudah di-set eksplisit di atas dari "tanggal_pembayaran_terakhir"
              // (field respons berbeda). Kalau tidak dilewati, loop generik ini
              // akan menimpa balik nilainya dengan tanggal_pembayaran mentah
              // karena kebetulan nama key sama dengan nama Form.Item.
              if (key === "tanggal_pembayaran") continue;
              const dateRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4}$/;
              const dateTimeRegex =
                /^[0-9]{2}\-[0-9]{2}\-[0-9]{4} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;

              const dateRegex2 = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/;
              const dateTimeRegex2 =
                /^[0-9]{4}\-[0-9]{2}\-[0-9]{2} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;
              if (dateRegex.test(data[key])) {
                //jika format tanggal
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key]),//.format("DD-MM-YYYY"),
                  [key]: data[key]
                  //[key]: moment(data[key], 'DD-MM-YYYY')
                });
              } else if (dateTimeRegex.test(data[key])) {
                //jika format tanggal dan jam
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key]),//.format("DD-MM-YYYY"),
                  [key]: data[key]
                });
              } else if (dateRegex2.test(data[key])) {
                //jika format tanggal
                // console.log(key, data[key]);
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key]),
                  [key]: moment(data[key]).format("DD-MM-YYYY")
                });
              } else if (dateTimeRegex2.test(data[key])) {
                //jika format tanggal dan jam
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key]),
                  [key]: moment(data[key]).format("DD-MM-YYYY")
                });
              } else {
                if (key == "pemilik_nama") {
                  this.formRef.current.setFieldsValue({
                    nama: data[key],
                  });
                } else if (key == "pemilik_alamat") {
                  this.formRef.current.setFieldsValue({
                    alamat: data[key],
                  });
                } else if (key == "pemilik_no_hp") {
                  this.formRef.current.setFieldsValue({
                    no_hp: data[key],
                  });
                } else if (key == "pemilik_nik") {
                  this.formRef.current.setFieldsValue({
                    nik: data[key],
                  });
                } else if (key == "desa_wp") {
                  this.formRef.current.setFieldsValue({
                    desa: data[key],
                  });
                } else if (key == "kecamatan_wp") {
                  this.formRef.current.setFieldsValue({
                    kecamatan: data[key],
                  });
                } else if (key == "kabupaten_wp") {
                  this.formRef.current.setFieldsValue({
                    kabupaten: data[key],
                  });
                } else if (key == "desa" || key == "kecamatan" || key == "kabupaten") {
                  // dilewati sengaja - nilai Form.Item-nya diisi dari
                  // desa_wp/kecamatan_wp/kabupaten_wp di atas, bukan dari
                  // field mentah Kendaraan ini (lihat diskusi 2026-10-14).
                } else if (key == "nomor_polisi_tengah") {
                  this.formRef.current.setFieldsValue({
                    no_polisi_tengah: data[key],
                  });
                } else if (key == "nomor_polisi_akhir") {
                  this.formRef.current.setFieldsValue({
                    no_polisi_belakang: data[key],
                  });
                } else if (key == "nomor_polisi_depan_lama") {
                  this.formRef.current.setFieldsValue({
                    no_polisi_depan_lama: data[key],
                  });
                } else if (key == "nomor_polisi_tengah_lama") {
                  this.formRef.current.setFieldsValue({
                    no_polisi_tengah_lama: data[key],
                  });
                } else if (key == "nomor_polisi_akhir_lama") {
                  this.formRef.current.setFieldsValue({
                    no_polisi_akhir_lama: data[key],
                  });
                } else if (key == "sd_swdkllj" && data[key] != null) {
                  this.formRef.current.setFieldsValue({
                    [key + "_picker"]: moment(data[key]),// "DD-MM-YYYY"),
                    [key]: moment(data[key]).format("DD-MM-YYYY"),
                  });
                } else if (key == "sd_notice") {
                  // Tgl PKB - kendaraan baru (belum pernah bayar) bisa kirim
                  // sd_notice null dari backend, berbeda dgn sd_swdkllj yang
                  // kebetulan sudah terisi utk kasus ini - jatuhkan ke tanggal
                  // hari ini spy field tidak kosong begitu saja.
                  const sdNoticeMoment = data[key] != null ? moment(data[key]) : moment();
                  this.formRef.current.setFieldsValue({
                    [key + "_picker"]: sdNoticeMoment,
                    [key]: sdNoticeMoment.format("DD-MM-YYYY"),
                  });
                }
                else if (key == "stnk_akhir") {
                  // Tgl STNK - sama alasannya dgn sd_notice di atas.
                  const stnkAkhirMoment = data[key] != null ? moment(data[key]) : moment();
                  this.formRef.current.setFieldsValue({
                    [key + "_picker"]: stnkAkhirMoment,
                    [key]: stnkAkhirMoment.format("DD-MM-YYYY")
                  });
                } else if (key == "stnk_mulai" && data[key] != null) {
                  this.formRef.current.setFieldsValue({
                    [key + "_picker"]: moment(data[key]),// "DD-MM-YYYY"),
                    [key]: moment(data[key]).format("DD-MM-YYYY")
                  });
                } else if ((key == "tanggal_faktur" && data[key] != null) || (key == "tanggal_kwitansi" && data[key] != null)) {
                  const temps = data[key].split("-");//2024-12-31
                  this.formRef.current.setFieldsValue({
                    [key + "_picker"]: moment(data[key]),// "DD-MM-YYYY"),
                    [key]: temps[2] + "-" + temps[1] + "-" + temps[0]
                  });
                } else if (key == "layanan" && data[key] != null) {
                  let temp = data[key];
                  if (Object.keys(temp).length > 0) {
                    temp = temp.reduce((result, itemLayanan, idxLayanan) => {
                      const layananMeta = data["layanan_list"] != undefined ? data["layanan_list"][idxLayanan] : null;
                      if (this.isNonPusatUser() && !this.isPendaftaranUlangOption(layananMeta || {})) {
                        return result;
                      }
                      const fieldReq = layananMeta != undefined ? layananMeta["field_requirements"] : {};
                      result.push(itemLayanan + "#" + JSON.stringify(fieldReq));
                      return result;
                    }, []);
                    if (this.isNonPusatUser() && temp.length == 0) {
                      this.setState({
                        field_requirements: {},
                      });
                    } else {
                      let tempReq = {};
                      temp.map((items) => {
                        const item = items.split("#")[1];
                        if (Object.keys(item).length > 0) {
                          Object.assign(tempReq, JSON.parse(item));
                        }
                      });
                      this.setState({
                        field_requirements: tempReq,
                      });
                    }
                    this.formRef.current.setFieldsValue({
                      [key]: temp
                    });
                  }
                } else {
                  this.formRef.current.setFieldsValue({
                    [key]: data[key],
                  });
                }
              }
              // if(key == 'gambar'){
              // 	this.setState({
              // 		preview_gambar: data[key]
              // 	});
              // }else{
              // 	this.formRef.current.setFieldsValue({
              // 		[key]: data[key]
              // 	});
              // }
            }

            this.setState({ listKecamatan: [], listDesa: [] }, () => {
              if (data.kabupaten_wp != null) {
                const ruleKec = {
                  destination: {
                    stateProgressName: "loadingKecamatan",
                    endPoint: configClass.apiUrl.kecamatan + "?regencies=" + data.kabupaten_wp,
                    stateDestination: "listKecamatan",
                  },
                  nextDestination: null,
                };
                this.getMasterList(ruleKec);
              }
              if (data.kecamatan_wp != null) {
                const ruleDesa = {
                  destination: {
                    stateProgressName: "loadingDesa",
                    endPoint: configClass.apiUrl.desa + "?district=" + data.kecamatan_wp,
                    stateDestination: "listDesa",
                  },
                  nextDestination: null,
                };
                this.getMasterList(ruleDesa);
              }
            });

            this.formRef.current.setFieldsValue({
              is_next: false,
            });



            // cekPreview('listKabupaten', ...) DIHAPUS - selalu menimpa balik
            // Form.Item kabupaten dengan data mentah Kendaraan (bukan dari
            // kabupaten_wp), padahal state kabupaten_dipilih (pemicu fetch
            // listKecamatan) sudah benar dari kabupaten_wp - akibatnya
            // Kabupaten di form kelihatan terisi tapi dropdown Kecamatan
            // kosong. listKabupaten sendiri daftar lengkap (fetch sekali
            // tanpa filter), jadi ensure-in-list ini memang sudah tidak
            // perlu. Lihat diskusi bug dropdown kecamatan/desa 2026-10-14.
            this.cekPreview('listJenisKendaraan', 'jenis_kendaraan', 'jenis_kendaraan_nama', 'jenis_kendaraan_kode');
            this.cekPreview('listKepemilikan', 'kepemilikan', 'kepemilikan_nama', 'kepemilikan_kode');
            this.cekPreview('listFungsi', 'fungsi', 'fungsi_nama', 'fungsi_kode');
            this.cekPreview('listMerek', 'merek', 'merek_nama', 'merek_kode');
            this.cekPreview('listTipe', 'tipe', 'tipe_nama', 'tipe_kode');

            message.destroy();
            this.setState({
              aksi: "edit",
              method: "put",
              idLama: data.id + "/",
            });

            if (data.is_block == true) {//cek blokir kendaraan
              this.setState({
                modalBlock: true
              })
            }
          }
        } else {
          const errTitle = "error preview data lama";
          this.setState({
            errTitle: errTitle,
            errMsg: datas,
          });
          message.error({ content: errTitle, duration: 2, key: "toast" });
        }
      })
      .catch((response) => {
        console.log("gagal_get_preview", response);
        message.error({
          content: "gagal request data, coba lagi",
          duration: 2,
          key: "toast",
        });
      });
  }

  // konfirmasiMutasi() dihapus - modal konfirmasi manual sudah diganti
  // banner info non-blocking (this.state.mutasiInfo) + keputusan otomatis
  // di backend saat submit form, berdasarkan Jenis Layanan yang dipilih
  // staf (lihat diskusi 2026-10-11). Endpoint kendaraan-eri/konfirmasi-mutasi/
  // tetap ada di backend untuk kompatibilitas, tidak dipanggil dari sini lagi.

  handleSubmit = (values) => {
    this.cekNjkbSebelumSimpan(values);
  };

  cekNjkbSebelumSimpan(values) {
    const tipe = values.tipe;
    const tahun_buat = values.tahun_buat;
    if (!tipe || !tahun_buat) {
      this.postDataPemilik(values);
      return;
    }
    this.setState({ loadingCekNjkb: true });
    this.props
      .ajaxViewHandler(
        "get",
        configClass.apiUrl.kendaraan + "njkb-preview/?tipe=" + tipe + "&tahun_buat=" + tahun_buat
      )
      .then((action) => {
        this.setState({ loadingCekNjkb: false });
        const { isSuccess, responseMsg: data } = extractResult(action);
        if (isSuccess && data != undefined && Number(data.njkb) === 0) {
          this.setState({
            pendingSubmitValues: values,
            modalNjkbKosong: true,
          });
        } else {
          this.postDataPemilik(values);
        }
      })
      .catch((response) => {
        console.log("gagal_cek_njkb", response);
        this.setState({ loadingCekNjkb: false });
        this.postDataPemilik(values);
      });
  }

  // Preview NJKB realtime (tipe+tahun_buat) - pola sama FormPendaftaran.jsx,
  // ditampilkan sbg Tag di bawah field Tahun Buat, TIDAK menggantikan
  // cekNjkbSebelumSimpan() (yang cuma dicek sekali saat submit).
  fetchNjkbPreview(tipe, tahun_buat) {
    if (!tipe || !tahun_buat) {
      this.setState({ njkbPreview: null });
      return;
    }
    clearTimeout(this._njkbPreviewTimeout);
    this._njkbPreviewTimeout = setTimeout(() => {
      this.setState({ loadingNjkbPreview: true });
      this.props
        .ajaxViewHandler(
          "get",
          configClass.apiUrl.kendaraan + "njkb-preview/?tipe=" + tipe + "&tahun_buat=" + tahun_buat
        )
        .then((action) => {
          const { isSuccess, responseMsg: data } = extractResult(action);
          this.setState({
            loadingNjkbPreview: false,
            njkbPreview: isSuccess && data != undefined ? data : null,
          });
        })
        .catch(() => {
          this.setState({ loadingNjkbPreview: false, njkbPreview: null });
        });
    }, 400);
  }



  reset() {
    this.formRef.current.setFieldsValue({
      pasien: undefined,
      jenis: "barcode",
    });
    this.resetPasien();
    this.setState({
      dataPasien: null,
      jenis: "barcode",
    });
    this.getDataRiwayat();
  }

  resetPasien() {
    // if (
    //   this.formRefPasien != undefined &&
    //   this.formRefPasien.current != undefined
    // ) {
    //   this.formRefPasien.current.resetFields();
    // }
  }

  async getPasienById(val) {
    message.loading({
      content: "Display data pasien...",
      duration: 0,
      key: "toast",
    });
    this.setState({
      errTitle: "",
      errMsg: "",
      dataPasien: null,
      skeletonPasien: true,
    });
    this.props
      .ajaxViewHandler("get", configClass.apiUrl.pasien + "/" + val)
      .then((action) => {
        this.setState({
          skeletonPasien: false,
        });
        const { isSuccess, responseMsg } = extractResult(action);
        if (isSuccess) {
          message.destroy();

          var response = responseMsg;
          this.setState({
            dataPasien: response,
          });
        } else {
          const errTitle = "gagal menampilkan data pasien";
          message.error({ content: errTitle, duration: 2, key: "toast" });
          this.setState({
            errTitle: errTitle,
            errMsg: responseMsg,
          });
        }
      })
      .catch((response) => {
        console.log("gagal_preview_pasien", response);
        this.setState({
          skeletonPasien: false,
        });
        message.error({
          content: "kesalahan pengiriman data, coba lagi",
          duration: 2,
          key: "toast",
        });
      });
  }

  async getDataPemilik(nik) {
    message.loading({
      content: "Pengecekan kepemilikan...",
      duration: 0,
      key: "toast",
    });
    //console.log('master/api/desa/?limit='+limit+'&offset='+offset);

    this.props
      .ajaxViewHandler(
        "get",
        configClass.apiUrl.pemilik +
        "?nik=" +
        nik
      )
      .then((action) => {
        const { isSuccess, responseMsg: datas } = extractResult(action);
        if (isSuccess) {
          if (datas.results != undefined) {
            const data = datas.results;
            if (data.length == 0) {
              message.warning({ content: "data kepemilikan tidak ditemukan", duration: 2, key: "toast" });
            } else {
              message.destroy();
            }
            for (var key in data) {
              const dateRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4}$/;
              const dateTimeRegex =
                /^[0-9]{2}\-[0-9]{2}\-[0-9]{4} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;

              const dateRegex2 = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/;
              const dateTimeRegex2 =
                /^[0-9]{4}\-[0-9]{2}\-[0-9]{2} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;
              if (dateRegex.test(data[key])) {
                //jika format tanggal
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key], "DD-MM-YYYY"),
                  [key]: moment(data[key]).format('DD-MM-YYYY')
                });
              } else if (dateTimeRegex.test(data[key])) {
                //jika format tanggal dan jam
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key], "DD-MM-YYYY HH:mm:ss"),
                  [key]: moment(data[key]).format('DD-MM-YYYY HH:mm:ss')
                });
              } else if (dateRegex2.test(data[key])) {
                //jika format tanggal
                // console.log(key, data[key]);
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key], "DD-MM-YYYY"),
                  [key]: moment(data[key]).format("DD-MM-YYYY"),
                  //[key]: moment(data[key], 'DD-MM-YYYY')
                });
              } else if (dateTimeRegex2.test(data[key])) {
                //jika format tanggal dan jam
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key], "DD-MM-YYYY HH:mm:ss"),
                  [key]: moment(data[key]).format("DD-MM-YYYY HH:mm:ss"),
                });
              } else {
                this.formRef.current.setFieldsValue({
                  [key]: data[key],
                });
              }
            }
          }
        } else {
          const errTitle = "error get data";
          message.error({ content: errTitle, duration: 2, key: "toast" });
        }
      })
      .catch((response) => {
        console.log("gagal_get_wp", response);
        message.error({
          content: "gagal cek wp, coba lagi",
          duration: 2,
          key: "toast",
        });
      });
  }

  async postDataPemilik(datas) {
    message.loading({ content: "Memproses...", duration: 0, key: "toast" });
    this.setState({
      errTitle: "",
      errMsg: "",
      loadingButton: true,
    });
    this.props
      .ajaxHandler("post", configClass.apiUrl.pemilik, datas, false, true)
      .then((action) => {
        const { isSuccess, responseMsg } = extractResult(action);
        if (isSuccess) {
          // message.success({ content: 'berhasil melakukan registrasi', duration: 2, key: 'toast' });

          var response = responseMsg;
          this.postDataKendaraan(datas, response.id);
        } else {
          const errTitle = "gagal menyimpan data pemilik";
          message.error({ content: errTitle, duration: 2, key: "toast" });
          this.setState({
            loadingButton: false,
            errTitle: errTitle,
            errMsg: JSON.stringify(responseMsg),
          });
        }
      })
      .catch((response) => {
        console.log("gagal_post_pemilik", response);
        this.setState({
          loadingButton: false,
        });
        message.error({
          content: "kesalahan pengiriman data pemilik, coba lagi",
          duration: 2,
          key: "toast",
        });
      });
  }

  async postDataKendaraan(datas, idPemilik) {
    var dataKendaraan = datas;
    // if (this.state.pemilik_lama == null) {
    //   dataKendaraan.pemilik = idPemilik;
    // } else {
    //   dataKendaraan.pemilik = this.state.pemilik_lama;
    // }
    dataKendaraan.pemilik = idPemilik;

    dataKendaraan.nomor_polisi =
      datas.no_polisi_depan + datas.no_polisi_tengah + datas.no_polisi_belakang;
    dataKendaraan.nomor_polisi_lama =
      datas.no_polisi_depan_lama +
      datas.no_polisi_tengah_lama +
      datas.no_polisi_akhir_lama;

    message.loading({ content: "Memproses...", duration: 0, key: "toast" });
    this.props
      .ajaxHandler(
        this.state.method,
        configClass.apiUrl.kendaraan + this.state.idLama,
        dataKendaraan,
        false,
        true
      )
      .then((action) => {
        const { isSuccess, responseMsg } = extractResult(action);
        if (isSuccess) {
          message.success({
            content: "berhasil menyimpan pendaftaran",
            duration: 2,
            key: "toast",
          });
          this.setState({
            pemilik_lama: null,
            loadingButton: false,
            isOpenForm: false,

            isSukses: true,
            redirect_nopol: datas.no_polisi_tengah + datas.no_polisi_belakang,
          });
        } else {
          const errTitle = "gagal menyimpan data kendaraan";
          const nonFieldErrors = (responseMsg && responseMsg.non_field_errors)
            ? responseMsg.non_field_errors.toString()
            : "";
          if (nonFieldErrors.toLowerCase() == "nomor polisi ini sudah terdaftar") {
            message.error({ content: errTitle, duration: 2, key: "toast" });
            this.setState({
              pemilik_lama: null,
              loadingButton: false,
              isOpenForm: false,
              isDaftar: true,
              redirect_nopol: datas.no_polisi_tengah + datas.no_polisi_belakang,
            });
          } else if (nonFieldErrors.toLowerCase().includes("masih aktif")) {
            message.destroy();
            this.setState({
              loadingButton: false,
              modalMasaPajakAktif: true,
              masaPajakAktifMsg: nonFieldErrors,
            });
          } else {
            message.error({ content: errTitle, duration: 2, key: "toast" });
            this.setState({
              loadingButton: false,
              errTitle: errTitle,
              errMsg: JSON.stringify(responseMsg),
            });
          }
        }

      })
      .catch((response) => {
        console.log("gagal_post_kendaraan", response);
        this.setState({
          loadingButton: false,
        });
        message.error({
          // content: "kesalahan pengiriman data kendaraan, coba lagi",
          content: JSON.stringify(response),
          duration: 2,
          key: "toast",
        });
      });
  }

  handleReset() {
    this.setState({
      isOpenForm: false,
    });
  }

  handleSubmitPasien = (values) => {
    var datas = new FormData();
    for (var key in values) {
      if (values[key] == undefined) {
        datas.append(key, "");
      } else {
        if (key == "nama" || key == "tempat_lahir") {
          datas.append(key, values[key].toString().toUpperCase());
        } else if (key == "email") {
          datas.append(key, values[key].toString().toLowerCase());
        } else {
          datas.append(key, values[key].toString());
        }
      }
    }
    // datas.append('provider', this.props.id);
    this.postDataPasien(datas);
  };

  async postDataPasien(datas) {
    message.loading({ content: "Memproses...", duration: 0, key: "toast" });
    this.setState({
      errTitle: "",
      errMsg: "",
    });
    this.props
      .ajaxHandler("post", configClass.apiUrl.pasien + "/", datas, true, true)
      .then((action) => {
        this.setState({
          loadingButton: false,
        });
        const { isSuccess, responseMsg } = extractResult(action);
        if (isSuccess) {
          message.success({
            content: "berhasil menyimpan data",
            duration: 2,
            key: "toast",
          });
          var response = responseMsg;
          this.formRef.current.setFieldsValue({
            pasien: response.id + "",
          });
          //preview yang berbentuk list
          const rule = [
            {
              destination: {
                stateProgressName: "loadingPasien_searching",
                endPoint: configClass.apiUrl.pasien + "/" + response.id,
                stateDestination: "listPasien",
              },
              nextDestination: null,
            },
          ];

          this.setState({
            errComponent: false,
            modalBaru: false,
          });
          rule.map((item, index) => {
            this.getMasterList(item);
          });
          this.resetPasien();
          this.getPasienById(response.id);
        } else {
          const errTitle = "gagal menyimpan data";
          message.error({ content: errTitle, duration: 2, key: "toast" });
          this.setState({
            errTitle: errTitle,
            errMsg: responseMsg,
          });
        }
      })
      .catch((response) => {
        console.log("gagal_post", response);
        this.setState({
          loadingButton: false,
        });
        message.error({
          content: "kesalahan pengiriman data, coba lagi",
          duration: 2,
          key: "toast",
        });
      });
  }

  loadMasterList() {
    const rule = [
      {
        destination: {
          stateProgressName: "loadingKabupaten",
          endPoint: configClass.apiUrl.kabupaten,
          stateDestination: "listKabupaten",
        },
        nextDestination: {
          stateProgressName: "loadingGolongan",
          endPoint: configClass.apiUrl.golongan,
          stateDestination: "listGolongan",
          next: null,
        },
      },
      {
        destination: {
          stateProgressName: "loadingKepemilikan",
          endPoint: configClass.apiUrl.kepemilikan,
          stateDestination: "listKepemilikan",
        },
        nextDestination: {
          stateProgressName: "loadingFungsi",
          endPoint: configClass.apiUrl.fungsi,
          stateDestination: "listFungsi",
          next: null,
        },
      },
      {
        destination: {
          stateProgressName: "loadingJenisKendaraan",
          endPoint: configClass.apiUrl.jenis_kendaraan,
          stateDestination: "listJenisKendaraan",
        },
        nextDestination: null,
      },
      {
        destination: {
          stateProgressName: "loadingTipe",
          endPoint: configClass.apiUrl.tipe,
          stateDestination: "listTipe",
        },
        nextDestination: {
          stateProgressName: "loadingBahanBakar",
          endPoint: configClass.apiUrl.bahan_bakar,
          stateDestination: "listBahanBakar",
          next: null,
        },
      },
      {
        destination: {
          stateProgressName: "loadingWarnaPlat",
          endPoint: configClass.apiUrl.warna_plat,
          stateDestination: "listWarnaPlat",
        },
        nextDestination: {
          stateProgressName: "loadingJenisLayanan",
          endPoint: configClass.apiUrl.jenis_layanan,
          stateDestination: "listJenisLayanan",
          next: null,
        },
      },
    ];

    this.setState({
      errComponent: false,
    });

    rule.map((item, index) => {
      if (index == rule.length - 1) {
        this.getMasterList(item, true);
      } else {
        this.getMasterList(item);
      }
    });
  }

  async getMasterList(rule, isFinal = false) {
    var destination = rule.destination;
    var nextDestination = rule.nextDestination;
    this.setState({ [destination.stateProgressName]: true });
    this.props
      .ajaxViewHandler("get", destination.endPoint)
      .then((action) => {
        const { isSuccess, responseMsg: data } = extractResult(action);
        if (isSuccess) {
          if (data.count != undefined) {
            let newState = null;
            if (this.state[destination.stateDestination].length == 0) {
              newState = data;
              // if(destination.stateProgressName.toLowerCase().includes("JenisLayanan")){
              //   let templistJenisLayananRequirement = data.results
              // }
            } else {
              if (destination.stateProgressName.includes("_searching")) {
                newState = data;
              } else {
                const oldState = this.state[destination.stateDestination];
                newState = {
                  count: data.count,
                  next: data.next,
                  previous: data.previous,
                  results: [...oldState.results, ...data.results],
                };
              }
            }
            this.setState({
              [destination.stateDestination]: newState,
            });
          } else if (data.results != undefined) {
            this.setState({
              [destination.stateDestination]: data.results,
            });
          } else {
            if (Array.isArray(data)) {
              this.setState({
                [destination.stateDestination]: data,
              });
            } else {
              this.setState({
                [destination.stateDestination]: [data],
              });
            }
          }
          if (isFinal) {
            if (this.props.match.params.id != undefined) {
              // this.preview(this.props.match.params.id);
            }
          }
        } else {
          this.setState({
            errComponent: true,
          });
        }
        this.setState({ [destination.stateProgressName]: false });
      })
      .catch((response) => {
        //console.log('gagal_get_master', response);
        message.error({
          content: "gagal request data, coba lagi",
          duration: 2,
          key: "toast",
        });
        this.setState({
          errTitle: "gagal request data master",
          errMsg: response,
        });
        this.setState({ [destination.stateProgressName]: false });
      });
    //next function
    if (nextDestination != null) {
      const next = {
        destination: {
          stateProgressName: nextDestination.stateProgressName,
          endPoint: nextDestination.endPoint,
          stateDestination: nextDestination.stateDestination,
        },
        nextDestination: nextDestination.next,
      };
      this.getMasterList(next);
    }
  }

  isNonPusatUser() {
    return (
      this.props.waktu_akses != undefined &&
      this.props.waktu_akses != null &&
      this.props.waktu_akses.is_pusat === false
    );
  }

  isWilayahMismatch() {
    return !!(
      this.state.kabupaten_dipilih &&
      String(this.state.kabupaten_dipilih) !== String(this.props.kabupaten_id)
    );
  }

  isMutasiTerdeteksi() {
    // mutasiInfo diisi saat backend mendeteksi rangka+mesin cocok dgn baris
    // lokal nopol LAIN (KendaraanEriViewset.list cabang existing_lain) -
    // sinyal mutasi yang andal (identitas fisik), beda dari cocok-nama wilayah.
    return this.state.mutasiInfo != null;
  }

  isPendaftaranUlangOption(item = {}) {
    const kode = String(item.kode != undefined ? item.kode : "").trim();
    if (kode != "") {
      return kode === "02" || kode === "2" || kode === "73";
    }
    const nama = String(item.nama != undefined ? item.nama : "").toUpperCase().trim();
    return nama === "PENDAFTARAN ULANG" || nama === "PENDAFTARAN ULANG 5 TAHUN";
  }

  isLayanan73InSelection(val) {
    const ls = this.state["listJenisLayanan"];
    if (!ls) return false;
    const opts = ls.count !== undefined ? ls.results : ls;
    if (!Array.isArray(opts)) return false;
    return val.some(v => {
      const id = parseInt(String(v).split("#")[0]);
      const item = opts.find(l => l.id === id);
      return item && String(item.kode).trim() === "73";
    });
  }

  batalkanUptLain() {
    const { batalUptLainData, batalAlasan, batalKeterangan, batalUptLainNoPol } = this.state;
    if (!batalAlasan) {
      message.error('Alasan pembatalan harus dipilih.');
      return;
    }
    this.setState({ loadingBatalUptLain: true });
    this.props.ajaxHandler(
      'post',
      configClass.apiUrl.penetapan + 'batalkan-upt-lain/',
      { tagihan_id: batalUptLainData.tagihan_id, alasan: batalAlasan, keterangan_tambahan: batalKeterangan },
      false,
      true
    ).then((action) => {
      this.setState({ loadingBatalUptLain: false });
      const { isSuccess, responseMsg } = extractResult(action);
      if (isSuccess) {
        message.success({ content: 'Pendaftaran di UPT lain berhasil dibatalkan.', duration: 3, key: 'toast' });
        this.setState({ modalBatalUptLain: false });
        this.previewData(batalUptLainNoPol);
      } else {
        const errMsg = (responseMsg && responseMsg.error) || 'Gagal membatalkan transaksi.';
        message.error({ content: errMsg, duration: 4, key: 'toast' });
      }
    });
  }

  closeModalBandingKendaraan = () => {
    this.setState({ modalBandingKendaraan: false });
  };

  terapkanDataKendaraanEri = () => {
    const k = this.state.kendaraanEri;
    if (!k) return;

    const fieldsToSet = {};

    // Field teks/angka langsung - cuma ditimpa kalau ERI punya nilai.
    const plainFields = ['nomor_rangka', 'nomor_mesin', 'tahun_buat', 'silinder', 'warna', 'no_bpkb', 'roda'];
    plainFields.forEach((f) => {
      const info = k[f];
      const val = info && info.eri;
      if (val !== null && val !== undefined && val !== '') {
        fieldsToSet[f] = val;
      }
    });

    // Field FK (Select lazy-load dari generateSelect()) - cuma ditimpa
    // kalau ERI berhasil diresolusi ke master lokal (eri_id terisi).
    // Opsi sintetis disisipkan ke state listX supaya Select bisa langsung
    // render labelnya tanpa perlu scroll/ketik dulu - kalau tidak, value
    // ke-set tapi tampilannya kosong karena generateSelect() cuma render
    // opsi dari state listX, bukan dari value form (lihat diskusi 2026-10-14).
    const fkMap = {
      tipe: 'listTipe',
      merek: 'listMerek',
      warna_plat: 'listWarnaPlat',
      bahan_bakar: 'listBahanBakar',
    };
    const listUpdates = {};
    Object.keys(fkMap).forEach((field) => {
      const info = k[field];
      if (info && info.eri_id) {
        fieldsToSet[field] = info.eri_id;
        const listKey = fkMap[field];
        const current = this.state[listKey];
        const currentResults = current && current.count !== undefined
          ? current.results
          : (Array.isArray(current) ? current : []);
        const sudahAda = (currentResults || []).some((item) => item.id === info.eri_id);
        if (!sudahAda) {
          const sintetis = { id: info.eri_id, nama: info.eri_label, kode: '' };
          listUpdates[listKey] = current && current.count !== undefined
            ? { ...current, results: [sintetis, ...currentResults] }
            : [sintetis, ...currentResults];
        }
      }
    });

    this.setState(listUpdates, () => {
      this.formRef.current.setFieldsValue(fieldsToSet);
      if (fieldsToSet.merek) {
        this.setState({ merek_dipilih: fieldsToSet.merek });
      }
      if (fieldsToSet.tipe) {
        const tahunVal = fieldsToSet.tahun_buat || this.formRef.current.getFieldValue('tahun_buat');
        this.fetchNjkbPreview(fieldsToSet.tipe, tahunVal);
      }
      message.success({ content: 'Data kendaraan dari ERI diterapkan.', duration: 3, key: 'toast' });
      this.setState({ modalBandingKendaraan: false });
    });
  };

  renderModalBandingKendaraan() {
    const { modalBandingKendaraan, kendaraanEri, isMobile } = this.state;
    if (!modalBandingKendaraan || !kendaraanEri) return null;

    const plainRows = [
      { label: 'Nomor Rangka', key: 'nomor_rangka' },
      { label: 'Nomor Mesin', key: 'nomor_mesin' },
      { label: 'Tahun Buat', key: 'tahun_buat' },
      { label: 'Silinder (CC)', key: 'silinder' },
      { label: 'Warna Kendaraan', key: 'warna' },
      { label: 'Nomor BPKB', key: 'no_bpkb' },
      { label: 'Jumlah Roda', key: 'roda' },
    ];
    const fkRows = [
      { label: 'Tipe', key: 'tipe' },
      { label: 'Merek', key: 'merek' },
      { label: 'Warna Plat', key: 'warna_plat' },
      { label: 'Bahan Bakar', key: 'bahan_bakar' },
    ];

    // Normalisasi longgar (trim + uppercase) sebelum dibandingkan - supaya
    // beda kapital/spasi ekor tidak salah ditandai "Beda" padahal maknanya
    // sama (mis. "putih" vs "PUTIH ").
    const normalisasi = (v) => (v === null || v === undefined ? '' : String(v).trim().toUpperCase());

    const dataSource = [
      ...plainRows.map((r) => {
        const info = kendaraanEri[r.key];
        const eriVal = info ? info.eri : null;
        const lokalVal = info ? info.lokal : null;
        const tidakDitemukan = eriVal === null || eriVal === undefined || eriVal === '';
        return {
          key: r.key,
          label: r.label,
          lokal: lokalVal,
          eri: eriVal,
          tidakDitemukan,
          beda: !tidakDitemukan && normalisasi(lokalVal) !== normalisasi(eriVal),
        };
      }),
      ...fkRows.map((r) => {
        const info = kendaraanEri[r.key];
        const lokalVal = info ? info.lokal_label : null;
        const eriVal = info ? info.eri_label : null;
        const tidakDitemukan = !(info && info.eri_id);
        return {
          key: r.key,
          label: r.label,
          lokal: lokalVal,
          eri: eriVal,
          tidakDitemukan,
          beda: !tidakDitemukan && normalisasi(lokalVal) !== normalisasi(eriVal),
        };
      }),
    ];

    const columns = [
      { title: 'Field', dataIndex: 'label', key: 'label', width: 130 },
      { title: 'Data Lokal', dataIndex: 'lokal', key: 'lokal', render: (v) => (v || v === 0 ? v : '-') },
      {
        title: 'Data ERI', dataIndex: 'eri', key: 'eri',
        render: (v, row) => row.tidakDitemukan
          ? <Text type="secondary" italic>tidak ditemukan di master lokal</Text>
          : <Text strong style={{ color: row.beda ? '#d4380d' : '#1e4d8a' }}>{v}</Text>,
      },
      {
        title: 'Status', key: 'status', width: 90, align: 'center',
        render: (_, row) => row.tidakDitemukan
          ? <Tag>-</Tag>
          : row.beda
            ? <Tag color="orange">Beda</Tag>
            : <Tag color="green">Sama</Tag>,
      },
    ];

    return (
      <Modal
        title="Banding Data Kendaraan: ERI vs Lokal"
        visible={true}
        onCancel={this.closeModalBandingKendaraan}
        width={isMobile ? '95%' : 640}
        footer={[
          <RoundedButton key="batal" onClick={this.closeModalBandingKendaraan}>Batal</RoundedButton>,
          <RoundedButton key="terapkan" type="primary" onClick={this.terapkanDataKendaraanEri}>
            Terapkan Semua
          </RoundedButton>,
        ]}
      >
        <Alert
          type="warning" showIcon style={{ marginBottom: 12 }}
          message="Field yang tidak ditemukan padanannya di master lokal TIDAK akan ditimpa - tetap pakai data lokal yang sudah ada."
        />
        <Table
          size="small"
          pagination={false}
          rowKey="key"
          dataSource={dataSource}
          columns={columns}
          rowClassName={(row) => (row.beda ? 'baris-beda-eri' : '')}
        />
        <style>{`.baris-beda-eri td { background: #fff7e6 !important; }`}</style>
      </Modal>
    );
  }

  getSelectOptions(stateName) {
    const listState = this.state["list" + stateName];
    if (listState == undefined) {
      return [];
    }

    const options = listState.count != undefined ? listState.results : listState;
    if (!Array.isArray(options)) {
      return [];
    }

    // Gate wilayah ("online kendaraan" -> cuma 02/73) TIDAK berlaku kalau
    // kendaraan ini terdeteksi mutasi: wilayah lokal yang basi (belum ikut
    // pindah) bikin isWilayahMismatch() false-positive & mengunci dropdown ke
    // 02/73, padahal justru kode MUTASI yang dibutuhkan utk memperbaikinya
    // (deadlock). Pakai mutasi_terdeteksi (rangka+mesin, andal) sbg sinyal,
    // BUKAN hasil cocok-nama wilayah yang rawan data ERI tidak konsisten -
    // lihat diskusi 2026-10-16.
    const wilayahGate = this.isWilayahMismatch() && !this.isMutasiTerdeteksi();
    if (stateName == "JenisLayanan" && (this.isNonPusatUser() || wilayahGate)) {
      return options.filter((item) => this.isPendaftaranUlangOption(item));
    }

    return options;
  }

  generateSelect(stateName, url, key, value, keyDisplay = "") {
    let convertName = stateName.toLowerCase();
    if (stateName == "jeniskendaraan") {
      convertName = "jenis_kendaraan";
    } else if (stateName == "bahanbakar") {
      convertName = "bahan_bakar";
    } else if (stateName == "warnaplat") {
      convertName = "warna_plat";
    }

    const selectOptions = this.getSelectOptions(stateName);

    return this.state["loading" + stateName] ? (
      <img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="50" />
    ) : (
      <RoundedSelect
        // autoFocus
        // labelInValue={stateName == "Tipe" ? true : false}
        showSearch
        placeholder={"Cari / Pilih " + stateName}
        optionFilterProp="children"
        onSearch={(val) => {
          if (stateName == "Tipe") {
            const rule = {
              destination: {
                stateProgressName: "loading" + stateName + "_searching",
                endPoint: configClass.apiUrl.tipe + "?merek=" + this.state.merek_dipilih + "&jenis=" + this.state.jenis_kendaraan_dipilih + "&search=" + val,
                stateDestination: "list" + stateName,
              },
              nextDestination: null,
            };
            this.getMasterList(rule);
          } else if (stateName == "Kecamatan") {
            const rule = {
              destination: {
                stateProgressName: "loading" + stateName + "_searching",
                endPoint: configClass.apiUrl.kecamatan + "?regencies=" + this.state.kabupaten_dipilih + "&search=" + val,
                stateDestination: "list" + stateName,
              },
              nextDestination: null,
            };
            this.getMasterList(rule);
          } else if (stateName == "Desa") {
            const rule = {
              destination: {
                stateProgressName: "loading" + stateName + "_searching",
                endPoint: configClass.apiUrl.desa + "?district=" + this.state.kecamatan_dipilih + "&search=" + val,
                stateDestination: "list" + stateName,
              },
              nextDestination: null,
            };
            this.getMasterList(rule);
          } else if (stateName == "Merek") {
            const jenisVal = this.state.jenis_kendaraan_dipilih;
            const rule = {
              destination: {
                stateProgressName: "loading" + stateName + "_searching",
                endPoint: url + "?search=" + val + (jenisVal ? "&jenis=" + jenisVal : ""),
                stateDestination: "list" + stateName,
              },
              nextDestination: null,
            };
            this.getMasterList(rule);
          } else {
            const rule = {
              destination: {
                stateProgressName: "loading" + stateName + "_searching",
                endPoint: url + "?search=" + val,
                stateDestination: "list" + stateName,
              },
              nextDestination: null,
            };
            this.getMasterList(rule);
          }
        }}
        onPopupScroll={(e) => {
          e.persist();
          let target = e.target;
          if (target.scrollTop + target.offsetHeight == target.scrollHeight) {
            if (
              this.state["list" + stateName].next != undefined &&
              this.state["list" + stateName].next != null
            ) {
              const rule = {
                destination: {
                  stateProgressName: "loading" + stateName + "Paging",
                  endPoint: this.state["list" + stateName].next,
                  stateDestination: "list" + stateName,
                },
                nextDestination: null,
              };
              this.getMasterList(rule);
            }
          }
        }}
        allowClear
        style={{
          width: "100%",
        }}
        onChange={(val) => {
          if (stateName == "Kabupaten") {
            this.formRef.current.setFieldsValue({ kecamatan: undefined, desa: undefined });
            this.setState({ kabupaten_dipilih: val, kecamatan_dipilih: "", listKecamatan: [], listDesa: [] }, () => {
              if (val) {
                const rule = {
                  destination: {
                    stateProgressName: "loadingKecamatan",
                    endPoint: configClass.apiUrl.kecamatan + "?regencies=" + val,
                    stateDestination: "listKecamatan",
                  },
                  nextDestination: null,
                };
                this.getMasterList(rule);
              }
            });
          } else if (stateName == "Kecamatan") {
            this.formRef.current.setFieldsValue({ desa: undefined });
            this.setState({ kecamatan_dipilih: val, listDesa: [] }, () => {
              if (val) {
                const rule = {
                  destination: {
                    stateProgressName: "loadingDesa",
                    endPoint: configClass.apiUrl.desa + "?district=" + val,
                    stateDestination: "listDesa",
                  },
                  nextDestination: null,
                };
                this.getMasterList(rule);
              }
            });
          } else if (stateName == "Merek") {
            this.setState({
              merek_dipilih: val,
              njkbPreview: null
            });
            const rule = {
              destination: {
                stateProgressName: "loadingTipe",
                endPoint: configClass.apiUrl.tipe + "?merek=" + this.state.merek_dipilih + "&jenis=" + this.state.jenis_kendaraan_dipilih,
                stateDestination: "listTipe",
              },
              nextDestination: null,
            };
            this.getMasterList(rule);
          } else if (stateName == "JenisKendaraan") {
            this.setState({
              jenis_kendaraan_dipilih: val,
              merek_dipilih: "",
              listMerek: [],
              listTipe: [],
              njkbPreview: null,
            }, () => {
              this.formRef.current.setFieldsValue({ merek: undefined, tipe: undefined });
            });
            if (val) {
              const ruleMerek = {
                destination: {
                  stateProgressName: "loadingMerek",
                  endPoint: configClass.apiUrl.merek + "?jenis=" + val,
                  stateDestination: "listMerek",
                },
                nextDestination: null,
              };
              this.getMasterList(ruleMerek);
            }
          } else if (stateName == "Tipe") {
            // this.formRef.current.setFieldsValue({
            //   koding: val.label.replace(/ /g, '').split("-")[0]
            // })
            const tahunVal = this.formRef.current.getFieldValue('tahun_buat');
            this.fetchNjkbPreview(val, tahunVal);
          } else if (stateName == "BahanBakar") {
            const selected = this.state.listBahanBakar.results.find((item) => item.id == val);

            // this.formRef.current.setFieldsValue({
            //   warna_plat: "PUTIH BIRU"
            // });

            // Cek apakah nilai terpilih adalah 'listrik' (case-insensitive)
            // if ((val || "").toString().toLowerCase() == "5") {
            if (selected.nama.toLowerCase() == "listrik") {
              this.formRef.current.setFieldsValue({
                warna_plat: "PUTIH BIRU",
              });
            }

          }

        }}
        size={"small"}
        disabled={!this.cekIsRequired(convertName)}
      >
        {this.state["loading" + stateName + "_searching"] == true && (
          <Select.Option value="">
            <Spin size="small" />
          </Select.Option>
        )}
        {selectOptions.map((item) => (
            <Select.Option
              value={item[key]}
              title={keyDisplay == "" ? item[key] + " - " + item[value] : item[keyDisplay] + " - " + item[value]}
            >
              {keyDisplay == ""
                ? item[key] + " - " + item[value]
                : item[keyDisplay] + " - " + item[value]}
            </Select.Option>
          ))}
        {this.state["list" + stateName] != undefined &&
          this.state["list" + stateName].next != undefined && (
            <Select.Option value="">
              <Spin size="small" />
            </Select.Option>
          )}
      </RoundedSelect>
    );
  }

  generateSelectMultiple(stateName, url, key, value, keyDisplay = "") {
    const selectOptions = this.getSelectOptions(stateName);

    return this.state["loading" + stateName] ? (
      <img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="50" />
    ) : (
      <RoundedSelect
        mode="multiple"
        autoFocus
        showSearch
        placeholder={"Cari / Pilih " + stateName}
        optionFilterProp="children"
        onSearch={(val) => {
          const rule = {
            destination: {
              stateProgressName: "loading" + stateName + "_searching",
              endPoint: url + "?search=" + val,
              stateDestination: "list" + stateName,
            },
            nextDestination: null,
          };
          this.getMasterList(rule);
        }}
        onPopupScroll={(e) => {
          e.persist();
          let target = e.target;
          if (target.scrollTop + target.offsetHeight == target.scrollHeight) {
            if (
              this.state["list" + stateName].next != undefined &&
              this.state["list" + stateName].next != null
            ) {
              const rule = {
                destination: {
                  stateProgressName: "loading" + stateName + "Paging",
                  endPoint: this.state["list" + stateName].next,
                  stateDestination: "list" + stateName,
                },
                nextDestination: null,
              };
              this.getMasterList(rule);
            }
          }
        }}
        allowClear
        style={{
          width: "100%",
        }}
        onChange={(val) => {
          // if (stateName == "Kabupaten") {
          //   const rule = {
          //     destination: {
          //       stateProgressName: "loadingKecamatan",
          //       endPoint: configClass.apiUrl.kecamatan + "?regencies=" + val,
          //       stateDestination: "listKecamatan",
          //     },
          //     nextDestination: null,
          //   };
          //   this.getMasterList(rule);
          // }
          if (stateName == "JenisLayanan") {
            if (this.isLayanan73InSelection(val)) {
              if (this.state.kabupaten_dipilih &&
                  String(this.state.kabupaten_dipilih) !== String(this.props.kabupaten_id)) {
                Modal.error({
                  title: 'LAYANAN TIDAK DIIZINKAN',
                  centered: true,
                  content: (
                    <div>
                      <p style={{ marginBottom: 0 }}>
                        KENDARAAN TERDAFTAR BUKAN DARI WILAYAH{' '}
                        <strong>{this.props.kabupaten_nama || '-'}</strong>
                        {', '}HANYA BOLEH MENDAFTARKAN DENGAN LAYANAN PENDAFTARAN ULANG
                      </p>
                    </div>
                  ),
                  okText: 'MENGERTI',
                });
                const ls = this.state["listJenisLayanan"];
                const opts = ls ? (ls.count !== undefined ? ls.results : (Array.isArray(ls) ? ls : [])) : [];
                val = val.filter(v => {
                  const id = parseInt(String(v).split("#")[0]);
                  const item = opts.find(l => l.id === id);
                  return !(item && String(item.kode).trim() === "73");
                });
                this.formRef.current.setFieldsValue({ layanan: val });
              }
            }
            if (this.state.jenis == "Kendaraan Baru") {
              this.setState({
                field_requirements: {}
              });
            } else {
              this.setState({
                field_requirements: {}
              }, () => {
                let tempReq = {};
                val.map((items, idx) => {
                  const item = items.split("#")[1];
                  if (Object.keys(item).length > 0) {
                    // tempReq = { ...tempReq, ...item };
                    Object.assign(tempReq, JSON.parse(item));
                  }
                });
                this.setState({
                  field_requirements: tempReq
                })
              });
            }
          }
        }}
        size={"small"}
      >
        {this.state["loading" + stateName + "_searching"] == true && (
          <Select.Option value="">
            <Spin size="small" />
          </Select.Option>
        )}
        {selectOptions.map((item) => (
            <Select.Option value={item[key] + "#" + JSON.stringify(item.field_requirements)}>
              {keyDisplay == ""
                ? item[key] + " - " + item[value]
                : item[keyDisplay] + " - " + item[value]}
            </Select.Option>
          ))}
        {this.state["list" + stateName] != undefined &&
          this.state["list" + stateName].next != undefined && (
            <Select.Option value="">
              <Spin size="small" />
            </Select.Option>
          )}
      </RoundedSelect>
    );
  }

  showmodalBaru() {
    this.setState({
      modalBaru: true,
    });
  }

  cekIsRequired(fieldName) {
    let result = true;
    const data = this.state.field_requirements;
    for (var key in data) {
      if (fieldName == key) {
        result = data[key]
      }
    }
    // console.log("field_name", fieldName)
    // console.log("result", result)
    return result;
  }

  showDetail = (judul, dataModal, is_flat = false) => {
    // alert(JSON.stringify(dataModal))
    this.setState({
      visibleModal: true,
      dataModal: {
        is_flat: is_flat,
        judul: judul,
        konten: {
          kolom: judul,
          value: dataModal
        },
      },
    });
  };
  /*
    async getDataRiwayat(limit = this.state.paginationRiwayat.pageSize, offset = 0, search = this.state.searchText) {
      this.setState({ loadingData: true });
      //console.log('master/api/desa/?limit='+limit+'&offset='+offset);
  
      this.props.ajaxViewHandler('get', configClass.apiUrl.history + '?limit=' + limit + '&offset=' + offset + '&search=' + search + '&' + this.state.filterData)
        .then(() => {
          const data = this.props.responseMsg;
          if (this.props.isSuccess) {
            const pagination = { ...this.state.pagination };
            pagination.total = data.count;
            this.setState({
              dataSource: data.results,
              pagination
            });
          } else {
            const errTitle = 'error get data';
            this.setState({
              errTitle: errTitle,
              errMsg: this.props.responseMsg
            });
            message.error({ content: errTitle, duration: 2, key: 'toast' });
          }
          this.setState({ loadingData: false });
        }).catch((response) => {
          console.log('gagal_get_preview', response);
          message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
          this.setState({ loadingData: false });
        });
    }
  */
  render() {
    // if(this.props.layanan_str.length>0 && this.props.layanan_str.includes('Pembelian / Pemesanan Obat') == false){
    // 	return <Redirect to="/admin/forbidden" />
    // }
    if (this.state.isSukses) {
      return <Redirect to={configClass.pageUrl.redirect_url + "?no_pol=" + this.state.redirect_nopol} />
    }
    if (this.state.isDaftar) {
      return <Redirect to={configClass.pageUrl.redirect_url + "?no_pol=" + this.state.redirect_nopol} />
    }

    return (
      <>
        <div>
          <Helmet>
            <title>
              {configClass.title + " | " + config.get_site_info().name}
            </title>
            <style>{`
              .tabel-riwayat-transaksi .ant-table-thead > tr > th {
                background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
                font-weight: 700;
                font-size: 12px;
                color: #0f2847;
                border-bottom: 2px solid #d0dff5;
              }
              .tabel-riwayat-transaksi .ant-table-tbody > tr > td {
                font-size: 12px;
                vertical-align: middle;
              }
              .tabel-riwayat-transaksi .ant-table-tbody > tr:hover > td {
                background: #e8f0fb !important;
              }
              .tabel-riwayat-transaksi .ant-table-tbody > tr:nth-child(even) > td {
                background: #fafafa;
              }
              .tabel-riwayat-transaksi .ant-table-tbody > tr:nth-child(even):hover > td {
                background: #e8f0fb !important;
              }
              .modal-riwayat-transaksi .ant-modal-body {
                padding: 0 !important;
              }
            `}</style>
          </Helmet>
          <div className="card" id="panel-transaksi">
            <Card
              className="konten"
              title={null}
            >
              <Form
                layout="horizontal"
                name="fdata"
                onFinish={this.handleSubmit}
                size="small"
                ref={this.formRef}
                initialValues={{
                  jenis: this.state.jenis,
                  no_polisi_depan: "KH",
                  is_next: false,
                }}
              >
                <Form.Item
                  name="is_next"
                  style={{
                    display: "none",
                  }}
                >
                  <Input type="hidden" />
                </Form.Item>

                <Row className="isi">
                  <Col span={24}>
                    <Row justify="start">
                      <Col span={24}>
                        <Input.Group compact>
                          {/* <Form.Item name="jenis" style={{ width: "20%" }}>
                            <Select
                              size="large"
                              showSearch
                              placeholder="pilih jenis"
                              optionFilterProp="children"
                              style={{
                                width: "100%",
                              }}
                              onChange={(val) => {
                                this.setState(
                                  {
                                    jenis: val,
                                    isOpenForm: val == "Kendaraan Lama" ? false : true
                                    // modalBaru: val == 'pasien baru' ? true : false
                                  },
                                  () => {
                                    // this.formRef.pasien.current.focus({cursor: 'start'});
                                    this.formRef.current.setFieldsValue({
                                      // pasien: undefined
                                    });
                                    if (val == "Kendaraan Baru") {
                                      this.setState(
                                        {
                                          jenis: val,
                                          isOpenForm : false,
                                        }
                                      );
                                      // this.formRefScroll.current.scrollTo(0, 0);
                                    }
                                  }
                                );
                              }}
                            >
                              <Select.Option value={"Kendaraan Lama"}>
                                <BarcodeOutlined /> Kendaraan Lama
                              </Select.Option>
                              <Select.Option value={"Kendaraan Baru"}>
                                <CarOutlined /> Kendaraan Baru
                              </Select.Option>
                            </Select>
                          </Form.Item> */}
                          {this.state.jenis == "Kendaraan Lama"
                            ?
                            <RoundedInput
                              height='28'
                              autoFocus
                              allowClear
                              style={{ width: "100%" }}
                              placeholder="Input Nomor Polisi, cth : KH1234XY"
                              onChange={(e) => {
                                const regex = /^\d+\.?\d*$/;
                                let startIdx = 0;
                                if (regex.test(e.target.value.charAt(0))) {
                                  startIdx = 0;
                                } else {
                                  if (regex.test(e.target.value.charAt(1))) {
                                    startIdx = 1;
                                  } else {
                                    startIdx = 2;
                                  }
                                }

                                const noKendaraan = e.target.value.substring(startIdx);

                                this.setState({
                                  // cari_no_pol: e.target.value,
                                  cari_no_pol: noKendaraan,
                                });
                              }}
                              prefix="KH"
                              value={this.state.cari_no_pol}
                              name="cari_no_pol"
                              size="large"
                              disabled={this.state.loadingDataKendaraan || this.state.isOpenForm}
                              onKeyPress={(event) => {
                                if (event.key == "Enter") {
                                  event.preventDefault();
                                  this.searchKendaraan(this.state.cari_no_pol);
                                }
                              }}
                            />
                            :
                            // <Input
                            //   size="large"
                            //   style={{ width: "80%" }}
                            //   disabled
                            // />
                            <RoundedInput
                              allowClear
                              style={{ width: "80%" }}
                              placeholder="Input Nomor Polisi Kendaraan Baru, cth : KH1234XY"
                              onChange={(e) => {
                                const regex = /^\d+\.?\d*$/;
                                let startIdx = 0;
                                if (regex.test(e.target.value.charAt(0))) {
                                  startIdx = 0;
                                } else {
                                  if (regex.test(e.target.value.charAt(1))) {
                                    startIdx = 1;
                                  } else {
                                    startIdx = 2;
                                  }
                                }

                                const noKendaraan = e.target.value.substring(startIdx);

                                this.setState({
                                  // cari_no_pol: e.target.value,
                                  cari_no_pol: noKendaraan,
                                });
                              }}
                              prefix="KH"
                              value={this.state.cari_no_pol}
                              name="cari_no_pol"
                              size="large"
                              disabled={this.state.loadingDataKendaraan || this.state.isOpenForm}
                              onKeyPress={(event) => {
                                if (event.key == "Enter") {
                                  event.preventDefault();
                                  this.searchKendaraan(this.state.cari_no_pol);
                                }
                              }}
                            />
                          }

                        </Input.Group>
                        <Divider />
                      </Col>
                    </Row>
                  </Col>

                  {this.state.isOpenForm == true && (
                    <Col
                      span={24}
                      style={{
                        overflow: "auto",
                        maxHeight: "calc(200vh - 300px)",
                        // background: "rgb(11,93,37, 0.2)",
                        padding: 10,
                        // boxShadow: "5px 10px"
                      }}
                      ref={this.formRefScroll}>
                      {this.state.mutasiInfo != null && (
                        <Alert
                          type="info"
                          showIcon
                          message="Kendaraan ini terdeteksi mutasi dari nopol lain"
                          description={`Nomor rangka dan nomor mesin sama dengan kendaraan nopol ${this.state.mutasiInfo.nopol_lama} (pemilik: ${this.state.mutasiInfo.pemilik_lama || "-"}). Pastikan Jenis Layanan yang dipilih sesuai (mis. Ganti No Kendaraan/Mutasi Masuk/STNK Plat Nomor Rahasia).`}
                          style={{ marginBottom: 16, borderRadius: 8 }}
                        />
                      )}
                      {(this.state.pemilikEri != null || this.state.kendaraanEri != null) && (
                        <Alert
                          type="info"
                          showIcon
                          message="Data ERI tersedia untuk dibandingkan dengan data lokal"
                          description={
                            <>
                              {this.state.pemilikEri != null && (
                                <div style={{ marginBottom: 8 }}>
                                  Pemilik ERI: <b>{this.state.pemilikEri.nama || "-"}</b> (untuk layanan Jual Beli/balik nama)
                                </div>
                              )}
                              {this.state.kendaraanEri != null && (
                                <div style={{ marginBottom: 8 }}>
                                  Rangka/mesin/tipe/merek/dll dari ERI bisa berbeda dari data lokal - tinjau dulu sebelum menerapkan.
                                </div>
                              )}
                              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                {this.state.pemilikEri != null && (
                                  <RoundedButton
                                    size="small"
                                    onClick={() => {
                                      const p = this.state.pemilikEri;
                                      const fieldsToSet = {
                                        nama: p.nama,
                                        alamat: p.alamat,
                                        no_hp: p.no_hp,
                                      };
                                      // NIK dari ERI bisa kosong/'-' - jangan timpa
                                      // kolom NIK kalau begitu, supaya fallback nopol
                                      // (solusi yang sudah ada saat NIK memang tidak
                                      // ada) tidak ketiban nilai kosong/'-' ini.
                                      const nikEri = (p.ktp || '').trim();
                                      if (nikEri && nikEri !== '-') {
                                        fieldsToSet.nik = nikEri;
                                      }
                                      this.formRef.current.setFieldsValue(fieldsToSet);
                                    }}
                                  >
                                    Isi Data Pemilik dari ERI
                                  </RoundedButton>
                                )}
                                {this.state.kendaraanEri != null && (
                                  <RoundedButton
                                    size="small"
                                    onClick={() => this.setState({ modalBandingKendaraan: true })}
                                  >
                                    Bandingkan &amp; Isi Data Kendaraan dari ERI
                                  </RoundedButton>
                                )}
                              </div>
                            </>
                          }
                          style={{ marginBottom: 16, borderRadius: 8 }}
                        />
                      )}
                      <Row className="form-penetapan-biaya">
                        <Col span={24}>
                          <Row justify="space-between">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Jenis Layanan
                            </Col>
                            <Col span={15} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="layanan"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelectMultiple(
                                  "JenisLayanan",
                                  configClass.apiUrl.jenis_layanan,
                                  "id",
                                  "nama",
                                  "kode"
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ paddingLeft: 3 }}>
                              <RoundedButton
                                height="32px"
                                style={{ width: "100%" }}
                                type="default"
                                warning
                                block
                                key="btn-riwayat-transaksi"
                                loading={this.state.loadingButton}
                                htmlType="button"
                                disabled={this.state.jenis == "Kendaraan Baru" ? true : false}
                                onClick={() => {
                                  this.setState({ isModalTransaksiHistory: true }, () => {
                                    this.getDataTransaksiHistory();
                                  })
                                }}
                              >
                                {!this.state.loadingButton && (
                                  <CarOutlined />
                                )}
                                Riwayat Transaksi
                              </RoundedButton>
                            </Col>
                            <Col span={3} style={{ paddingLeft: 3 }}>
                              <RoundedButton
                                height="32px"
                                style={{ width: "100%" }}
                                key="btn-riwayat-pemilik"
                                loading={this.state.loadingButton}
                                type="primary"
                                htmlType="button"
                                disabled={this.state.jenis == "Kendaraan Baru" ? true : false}
                                onClick={() => {
                                  this.setState({ isModalRiwayat: true }, () => {
                                    this.getDataRiwayat();
                                  })
                                }}
                              >
                                {!this.state.loadingButton && (
                                  <UserSwitchOutlined />
                                )}
                                Riwayat Pemilik
                              </RoundedButton>
                            </Col>

                          </Row>
                        </Col>
                        {/*
                      <Col span={24}>
                        <Row justify="space-between">
                          <Col span={3} style={{ textAlign: "right" }}>
                            Jenis Layanan
                          </Col>
                          <Col span={21} style={{ paddingLeft: 5 }}>
                            <Form.Item name="layanan">
                              {this.generateSelect(
                                "JenisLayanan",
                                configClass.apiUrl.jenis_layanan,
                                "id",
                                "nama",
                                "kode"
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                      */}
                        <Col span={24}>
                          <Row justify="start">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Nomor Polisi
                            </Col>
                            <Col span={1} style={{ paddingLeft: 5 }}>
                              <Form.Item name="no_polisi_depan">
                                <RoundedInput placeholder="KH" disabled={!this.props.is_superuser}/>
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ paddingLeft: 5 }}>
                              <Form.Item name="no_polisi_tengah">
                                <RoundedInput placeholder="1234" disabled={!this.props.is_superuser}/>
                              </Form.Item>
                            </Col>
                            <Col span={1} style={{ paddingLeft: 5 }}>
                              <Form.Item name="no_polisi_belakang">
                                <RoundedInput placeholder="YZ" disabled={!this.props.is_superuser}/>
                              </Form.Item>
                            </Col>
                            <Col span={1} style={{ paddingLeft: 5 }}>
                              SKUM
                            </Col>
                            <Col span={2} style={{ paddingLeft: 5 }}>
                              <Form.Item name="skum1">
                                <RoundedInput disabled={!this.cekIsRequired("skum1")} />
                              </Form.Item>
                            </Col>
                            <Col span={2} style={{ paddingLeft: 5 }}>
                              <Form.Item name="skum2">
                                <RoundedInput disabled={!this.cekIsRequired("skum2")} />
                              </Form.Item>
                            </Col>
                            <Col span={2} style={{ paddingLeft: 5 }}>
                              No. Urut
                            </Col>
                            <Col span={2} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="no_urut"
                              >
                                <RoundedInput disabled={!this.cekIsRequired("skuno_urutm2")} />
                              </Form.Item>
                            </Col>

                            <Col span={2} style={{ paddingLeft: 5 }}>
                              Kohir
                            </Col>
                            <Col span={3} style={{ paddingLeft: 5 }}>
                              <Form.Item name="kohir1">
                                <RoundedInput disabled={!this.cekIsRequired("kohir1")} />
                              </Form.Item>
                            </Col>
                            <Col span={2} style={{ paddingLeft: 5 }}>
                              <Form.Item name="kohir2">
                                <RoundedInput disabled={!this.cekIsRequired("kohir2")} />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="start">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Nomor Polisi Lama
                            </Col>
                            <Col span={1} style={{ paddingLeft: 5 }}>
                              <Form.Item name="no_polisi_depan_lama">
                                <RoundedInput placeholder="KH" disabled={!this.props.is_superuser} />
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ paddingLeft: 5 }}>
                              <Form.Item name="no_polisi_tengah_lama">
                                <RoundedInput placeholder="1234" disabled={!this.props.is_superuser} />
                              </Form.Item>
                            </Col>
                            <Col span={1} style={{ paddingLeft: 5 }}>
                              <Form.Item name="no_polisi_akhir_lama">
                                <RoundedInput placeholder="YZ" disabled={!this.props.is_superuser} />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        {/* <Col span={24}>
                        <Row justify="start">
                          <Col span={3} style={{ textAlign: "right" }}>
                            Nomor Polisi Lama
                          </Col>
                          <Col span={1} style={{ paddingLeft: 5 }}>
                            <Form.Item name="no_polisi_depan_lama">
                              <Input placeholder="KH" />
                            </Form.Item>
                          </Col>
                          <Col span={3} style={{ paddingLeft: 5 }}>
                            <Form.Item name="no_polisi_tengah_lama">
                              <Input placeholder="1234" />
                            </Form.Item>
                          </Col>
                          <Col span={1} style={{ paddingLeft: 5 }}>
                            <Form.Item name="no_polisi_akhir_lama">
                              <Input placeholder="YZ" />
                            </Form.Item>
                          </Col>
                          <Col span={1} style={{ paddingLeft: 5 }}>
                            Kohir
                          </Col>
                          <Col span={2} style={{ paddingLeft: 5 }}>
                            <Form.Item name="kohir1">
                              <Input disabled={!this.cekIsRequired("kohir1")} />
                            </Form.Item>
                          </Col>
                          <Col span={2} style={{ paddingLeft: 5 }}>
                            <Form.Item name="kohir2">
                              <Input disabled={!this.cekIsRequired("kohir2")} />
                            </Form.Item>
                          </Col>
                          <Col span={2} style={{ paddingLeft: 5 }}>
                            Tgl. Daftar
                          </Col>
                          <Col span={9} style={{ paddingLeft: 5 }}>
                            <Form.Item name="tgl_daftar_picker">
                              <DatePicker
                                placeholder="dd-mm-yyyy"
                                format="DD-MM-YYYY"
                                style={{ width: "100%" }}
                                onChange={(date, dateString) => {
                                  this.formRef.current.setFieldsValue({
                                    created_at: dateString,
                                  });
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              name="created_at"
                              style={{
                                display: "none",
                              }}
                            >
                              <Input type="hidden" />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col> */}
                        <Col span={24}>
                          <Row justify="start">
                            <Col span={3} style={{ textAlign: "right" }}>
                              No Identitas
                            </Col>
                            <Col span={21} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="nik"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                <RoundedInput
                                  disabled={!this.cekIsRequired("nik")}
                                  placeholder="cth: 1234567890123456"
                                  onChange={(e) => {
                                    this.getDataPemilik(e.target.value);
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ textAlign: "right" }}>
                              Nama WP/Pemilik
                            </Col>
                            <Col span={21} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="nama"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                <RoundedInput placeholder="cth: Budi Raharjo" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="start">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Alamat WP/Pemilik
                            </Col>
                            <Col span={21} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="alamat"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                <RoundedInput placeholder="cth: Jl. Raya Indonesia No 75, Bumi Insan Pertiwi" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="start">
                            <Col span={3} style={{ textAlign: "right" }}>
                              No Hp
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="no_hp"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                <RoundedInput disabled={!this.cekIsRequired("no_hp")} placeholder="cth: 081234567890" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="space-between">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Kabupaten
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="kabupaten"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "Kabupaten",
                                  configClass.apiUrl.kabupaten,
                                  "id",
                                  "name"
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={2} style={{ textAlign: "right" }}>
                              Kecamatan
                            </Col>
                            <Col span={5} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="kecamatan"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "Kecamatan",
                                  configClass.apiUrl.kecamatan,
                                  "id",
                                  "name"
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={2} style={{ textAlign: "right" }}>
                              Desa
                            </Col>
                            <Col span={5} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="desa"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "Desa",
                                  configClass.apiUrl.desa,
                                  "id",
                                  "name"
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="start">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Kepemilikan Ke
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="kepemilikan_ke"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                <RoundedInput disabled={!this.cekIsRequired("kepemilikan_ke")} placeholder="cth: 1" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="start">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Kode Kepemilikan
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="kepemilikan"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "Kepemilikan",
                                  configClass.apiUrl.kepemilikan,
                                  "id",
                                  "nama",
                                  "kode"
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ textAlign: "right" }}>
                              Tanggal Kwitansi
                            </Col>
                            <Col span={11} style={{ paddingLeft: 5 }}>
                              <Form.Item name="tanggal_kwitansi_picker">
                                <RoundedDatePicker
                                  placeholder="dd-mm-yyyy"
                                  format="DD-MM-YYYY"
                                  style={{ width: "100%" }}
                                  onChange={(date, dateString) => {
                                    this.formRef.current.setFieldsValue({
                                      tanggal_kwitansi: dateString,
                                    });
                                  }}
                                  disabled={!this.cekIsRequired("tanggal_kwitansi")}
                                />
                              </Form.Item>
                              <Form.Item
                                name="tanggal_kwitansi"
                                style={{
                                  display: "none",
                                }}
                              >
                                <RoundedInput type="hidden" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="start">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Kode Fungsi
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="fungsi"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "Fungsi",
                                  configClass.apiUrl.fungsi,
                                  "id",
                                  "nama",
                                  "kode"
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ textAlign: "right" }}>
                              Tanggal Fiskal
                            </Col>
                            <Col span={11} style={{ paddingLeft: 5 }}>
                              <Form.Item name="tanggal_fiskal_picker">
                                <RoundedDatePicker
                                  placeholder="dd-mm-yyyy"
                                  format="DD-MM-YYYY"
                                  style={{ width: "100%" }}
                                  onChange={(date, dateString) => {
                                    this.formRef.current.setFieldsValue({
                                      tanggal_fiskal: dateString,
                                    });
                                  }}
                                  disabled={!this.cekIsRequired("tanggal_fiskal")}
                                />
                              </Form.Item>
                              <Form.Item
                                name="tanggal_fiskal"
                                style={{
                                  display: "none",
                                }}
                              >
                                <RoundedInput type="hidden" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="left">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Tanggal Faktur
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item name="tanggal_faktur_picker">
                                <RoundedDatePicker
                                  placeholder="dd-mm-yyyy"
                                  format="DD-MM-YYYY"
                                  style={{ width: "100%" }}
                                  onChange={(date, dateString) => {
                                    this.formRef.current.setFieldsValue({
                                      tanggal_faktur: dateString,
                                    });
                                  }}
                                  disabled={!this.cekIsRequired("tanggal_faktur")}
                                />
                              </Form.Item>
                              <Form.Item
                                name="tanggal_faktur"
                                style={{
                                  display: "none",
                                }}
                              >
                                <RoundedInput type="hidden" />
                              </Form.Item>
                            </Col>
                            {/* <Col span={3} style={{ textAlign: "right" }}>
                            Koding
                          </Col>
                          <Col span={11} style={{ paddingLeft: 5 }}>
                            <Form.Item name="koding">
                              <Input disabled={!this.cekIsRequired("koding")} />
                            </Form.Item>
                          </Col> */}
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="space-between">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Jenis
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="jenis_kendaraan"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "JenisKendaraan",
                                  configClass.apiUrl.jenis_kendaraan,
                                  "id",
                                  "nama",
                                  "kode"
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ textAlign: "right" }}>
                              Merk
                            </Col>
                            <Col span={11} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="merek"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "Merek",
                                  configClass.apiUrl.merek,
                                  "id",
                                  "nama",
                                  "kode"
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="start">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Tipe
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="tipe"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "Tipe",
                                  configClass.apiUrl.tipe,
                                  "id",
                                  "nama",
                                  "kode"
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ textAlign: "right" }}>
                              Golongan
                            </Col>
                            <Col span={11} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="golongan"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "Golongan",
                                  configClass.apiUrl.golongan,
                                  "id",
                                  "nama",
                                  "kode"
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="space-between">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Tahun Buat
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item shouldUpdate={(prev, cur) => prev.tahun_buat !== cur.tahun_buat} noStyle>
                                {({ getFieldValue }) => {
                                  const tahunBuatKosong = !getFieldValue('tahun_buat') && getFieldValue('tahun_buat') !== 0;
                                  return (
                                    <Form.Item
                                      name="tahun_buat"
                                      rules={[
                                        {
                                          required: true,
                                          message: 'harus dipilih'
                                        }
                                      ]}
                                    >
                                      {/* Field ini normalnya terkunci (hanya superuser/level_user 2 yang boleh
                                          ubah tahun buat kendaraan existing), TAPI kalau backend/ERI tidak
                                          mengembalikan tahun_buat sama sekali (kosong), field WAJIB enabled
                                          supaya user biasa tetap bisa mengisi field required ini sendiri -
                                          tanpa ini, form terkunci total tanpa jalan keluar. */}
                                      <RoundedInput
                                        disabled={!tahunBuatKosong && !(this.props.is_superuser || this.props.level_user === 2)}
                                        placeholder="cth: 2021"
                                        onChange={(e) => {
                                          const tipeVal = this.formRef.current.getFieldValue('tipe');
                                          this.fetchNjkbPreview(tipeVal, e.target.value);
                                        }}
                                      />
                                    </Form.Item>
                                  );
                                }}
                              </Form.Item>
                              {(this.state.loadingNjkbPreview || this.state.njkbPreview != null) && (
                                <div style={{ marginTop: -8, marginBottom: 8 }}>
                                  {this.state.loadingNjkbPreview ? (
                                    <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#f5f5f5', borderColor: '#d9d9d9', color: '#8c8c8c', padding: '3px 12px' }}>
                                      <Spin size="small" style={{ marginRight: 6 }} />Mengecek NJKB...
                                    </Tag>
                                  ) : this.state.njkbPreview.is_njkb ? (
                                    <Tag style={{ borderRadius: 20, fontWeight: 700, fontSize: 11, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', padding: '3px 12px' }}>
                                      <DollarOutlined style={{ marginRight: 5 }} />
                                      NJKB Rp {Number(this.state.njkbPreview.njkb).toLocaleString('id-ID')}
                                    </Tag>
                                  ) : (
                                    <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#fffbe6', borderColor: '#ffe58f', color: '#ad6800', padding: '3px 12px' }}>
                                      <ExclamationCircleOutlined style={{ marginRight: 5 }} />
                                      NJKB belum tersedia
                                    </Tag>
                                  )}
                                </div>
                              )}
                            </Col>
                            <Col span={3} style={{ textAlign: "right" }}>
                              CC
                            </Col>
                            <Col span={11} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="silinder"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                <RoundedInput disabled={!this.cekIsRequired("silinder")} placeholder="cth: 150" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="space-between">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Warna
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="warna"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                <RoundedInput disabled={!this.cekIsRequired("warna")} placeholder="cth: merah" />
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ textAlign: "right" }}>
                              No. Rangka
                            </Col>
                            <Col span={11} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="nomor_rangka"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                <RoundedInput disabled={!this.cekIsRequired("nomor_rangka")} />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="space-between">
                            <Col span={3} style={{ textAlign: "right" }}>
                              No Mesin
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="nomor_mesin"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                <RoundedInput disabled={!this.cekIsRequired("nomor_mesin")} />
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ textAlign: "right" }}>
                              Kode BBM
                            </Col>
                            <Col span={11} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="bahan_bakar"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "BahanBakar",
                                  configClass.apiUrl.bahan_bakar,
                                  "id",
                                  "nama",
                                  "kode",
                                  true,
                                  {
                                    onChange: (value, option) => {
                                      alert(`Bahan bakar dipilih: ${option.label || option.children}`);
                                    }
                                  }

                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="start">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Jumlah Roda
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item name="roda">
                                <RoundedInput disabled={!this.cekIsRequired("roda")} placeholder="cth: 2" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="space-between">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Warna Plat
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="warna_plat"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                {this.generateSelect(
                                  "WarnaPlat",
                                  configClass.apiUrl.warna_plat,
                                  "id",
                                  "nama",
                                  "kode"
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={3} style={{ textAlign: "right" }}>
                              No. BPKB
                            </Col>
                            <Col span={11} style={{ paddingLeft: 5 }}>
                              <Form.Item
                                name="no_bpkb"
                                rules={[
                                  {
                                    required: true,
                                    message: 'harus dipilih'
                                  }
                                ]}
                              >
                                <RoundedInput disabled={!this.cekIsRequired("no_bpkb")} />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="space-between">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Tgl STNK
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item name="stnk_akhir_picker">
                                <RoundedDatePicker
                                  placeholder="dd-mm-yyyy"
                                  format="DD-MM-YYYY"
                                  style={{ width: "100%" }}
                                  onChange={(date, dateString) => {
                                    var currentDate = moment(date);
                                    var futureMonth = moment(currentDate).add(
                                      1,
                                      "Y"
                                    );
                                    var futureMonthEnd =
                                      moment(futureMonth).endOf("month");
                                    // var futureMonthString = moment(futureMonthEnd).format("DD-MM-YYYY");

                                    if (
                                      currentDate.date() != futureMonth.date() &&
                                      futureMonth.isSame(
                                        futureMonthEnd.format("YYYY-MM-DD")
                                      )
                                    ) {
                                      futureMonth = futureMonth.add(1, "d");
                                      // futureMonthString = moment(futureMonth).format("DD-MM-YYYY");
                                    }
                                    this.formRef.current.setFieldsValue({
                                      stnk_akhir: date,
                                      // tanggal_pembayaran_picker: futureMonth,
                                      // tanggal_pembayaran: futureMonthString
                                    });
                                  }}
                                  // disabled={!(this.props.is_superuser || this.props.level_user === 2)}
                                />
                              </Form.Item>
                              <Form.Item
                                name="stnk_akhir"
                                style={{
                                  display: "none",
                                }}
                              >
                                <RoundedInput type="hidden" />
                              </Form.Item>
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                              Tgl Pembayaran Terakhir
                            </Col>
                            <Col span={10} style={{ paddingLeft: 5 }}>
                              <Form.Item name="tanggal_pembayaran_picker">
                                <RoundedDatePicker
                                  placeholder="dd-mm-yyyy"
                                  format="DD-MM-YYYY"
                                  style={{ width: "100%" }}
                                  onChange={(date, dateString) => {
                                    this.formRef.current.setFieldsValue({
                                      tanggal_pembayaran: dateString,
                                    });
                                  }}
                                  disabled={!(this.props.is_superuser || this.props.level_user === 2)}
                                />
                              </Form.Item>
                              <Form.Item
                                name="tanggal_pembayaran"
                                style={{
                                  display: "none",
                                }}
                              >
                                <RoundedInput type="hidden" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="space-between">
                            <Col span={3} style={{ textAlign: "right" }}>
                              Tgl PKB
                            </Col>
                            <Col span={7} style={{ paddingLeft: 5 }}>
                              <Form.Item name="sd_notice_picker">
                                <RoundedDatePicker
                                  placeholder="dd-mm-yyyy"
                                  format="DD-MM-YYYY"
                                  style={{ width: "100%" }}
                                  onChange={(date, dateString) => {
                                    this.formRef.current.setFieldsValue({
                                      sd_notice: dateString,
                                    });
                                  }}
                                  // disabled={!(this.props.is_superuser || this.props.level_user === 2)}
                                />
                              </Form.Item>
                              <Form.Item
                                name="sd_notice"
                                style={{
                                  display: "none",
                                }}
                              >
                                <RoundedInput type="hidden" />
                              </Form.Item>
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                              Tgl Akhir SWDKLLJ
                            </Col>
                            <Col span={10} style={{ paddingLeft: 5 }}>
                              <Form.Item name="sd_swdkllj_picker">
                                <RoundedDatePicker
                                  placeholder="dd-mm-yyyy"
                                  format="DD-MM-YYYY"
                                  style={{ width: "100%" }}
                                  onChange={(date, dateString) => {
                                    this.formRef.current.setFieldsValue({
                                      sd_swdkllj: dateString,
                                    });
                                  }}
                                  disabled={!(this.props.is_superuser || this.props.level_user === 2)}
                                />
                              </Form.Item>
                              <Form.Item
                                name="sd_swdkllj"
                                style={{
                                  display: "none",
                                }}
                              >
                                <RoundedInput type="hidden" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="end">
                            <Col span={3} style={{ padding: 3 }}>
                              <RoundedButton
                                style={{ width: "100%" }}
                                key="btn-simpan"
                                loading={this.state.loadingButton || this.state.loadingCekNjkb}
                                type="primary"
                                htmlType="submit"
                                // disabled={this.state.errComponent ? true : false}
                              >
                                {!this.state.loadingButton && !this.state.loadingCekNjkb && (
                                  <CheckCircleOutlined />
                                )}
                                Simpan
                              </RoundedButton>
                            </Col>
                            <Col span={3} style={{ padding: 3 }}>
                              <RoundedButton
                                type="primary"
                                danger
                                block
                                key="btn-cancel"
                                disabled={this.state.loadingButton ? true : false}
                                style={{ width: "100%" }}
                                onClick={() => this.reset_nopol()}
                              >
                                <CloseCircleOutlined /> Reset
                              </RoundedButton>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  )}
                </Row>
              </Form>
            </Card>
          </div>
        </div>
        <Modal
          title="Riwayat Pemilik Kendaraan"
          visible={this.state.isModalRiwayat}
          footer={[]}
          closable={true}
          width={"80%"}
          onCancel={() => this.setState({ isModalRiwayat: false })}
        >
          <Table
            title={() =>
              <Row>
                <Col lg={8} sm={24} xs={24}><span className="konten-judul">Total {this.state.paginationRiwayat.total} record</span></Col>
                <Col lg={{ span: 8, offset: 8 }} sm={24} xs={24}>
                  <Input.Search
                    size="small"
                    placeholder="ketikkan pencarian"
                    onSearch={value => {
                      this.setState({
                        searchText: value
                      }, () => {
                        this.getDataRiwayat();
                      });
                    }}
                    allowClear
                  />
                </Col>
              </Row>
            }
            bordered
            columns={this.state.columnsRiwayat}
            dataSource={this.state.dataSourceRiwayat}
            loading={this.state.loadingDataRiwayat}
            scroll={{ x: 240, y: 450 }}
            size="small"
            pagination={this.state.paginationRiwayat}
            onChange={this.handleTableChangeRiwayat}
          />

        </Modal>

        <Modal
          title={
            <span>
              <CarOutlined style={{ marginRight: 8, color: '#1e4d8a' }} />
              Riwayat Transaksi Kendaraan
            </span>
          }
          visible={this.state.isModalTransaksiHistory}
          footer={[]}
          closable={true}
          centered
          width={this.state.isMobile ? '94%' : 1050}
          bodyStyle={{ padding: 0 }}
          className="modal-riwayat-transaksi"
          onCancel={() => this.setState({ isModalTransaksiHistory: false })}
        >
          {/* Stat banner */}
          <div style={{
            background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
            padding: this.state.isMobile ? '14px 18px' : '18px 24px',
            display: 'flex', alignItems: 'center', gap: this.state.isMobile ? 24 : 40, flexWrap: 'wrap',
          }}>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 11, marginBottom: 2 }}>
                <FileTextOutlined style={{ marginRight: 5 }} />Total Transaksi
              </div>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: this.state.isMobile ? 18 : 22 }}>
                {this.state.loadingTransaksiHistory ? '...' : this.state.dataSourceTransaksiHistory.length}
              </div>
            </div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 11, marginBottom: 2 }}>
                <DollarOutlined style={{ marginRight: 5 }} />Total Nominal
              </div>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: this.state.isMobile ? 18 : 22 }}>
                {this.state.loadingTransaksiHistory
                  ? '...'
                  : 'Rp ' + this.state.dataSourceTransaksiHistory.reduce((sum, r) => sum + (r.total_bayar || 0), 0).toLocaleString('id-ID')}
              </div>
            </div>
          </div>

          <div style={{ padding: this.state.isMobile ? 14 : 20 }}>
            {this.state.isMobile ? (
              <div>
                {this.state.loadingTransaksiHistory ? (
                  <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
                ) : this.state.dataSourceTransaksiHistory.length === 0 ? (
                  <Empty description="Tidak ada riwayat transaksi" style={{ padding: 30 }} />
                ) : (
                  this.state.dataSourceTransaksiHistory.map((row, idx) => this.renderTransaksiHistoryMobileCard(row, idx))
                )}
              </div>
            ) : (
              <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #f0f0f0' }}>
                <Table
                  className="tabel-riwayat-transaksi"
                  columns={this.state.columnsTransaksiHistory}
                  dataSource={this.state.dataSourceTransaksiHistory}
                  loading={this.state.loadingTransaksiHistory}
                  scroll={{ x: 1150, y: 450 }}
                  size="middle"
                  rowKey="id"
                  locale={{ emptyText: <Empty description="Tidak ada riwayat transaksi" style={{ padding: 20 }} /> }}
                  pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '25', '50'],
                    showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
                  }}
                />
              </div>
            )}
          </div>
        </Modal>

        <Modal
          title={
            <span>
              <FileTextOutlined style={{ marginRight: 8, color: '#1e4d8a' }} />
              Detail Transaksi
            </span>
          }
          visible={this.state.isModalDetailTransaksi}
          footer={[]}
          closable={true}
          centered
          width={this.state.isMobile ? '94%' : 760}
          bodyStyle={{ padding: 0 }}
          onCancel={() => this.setState({ isModalDetailTransaksi: false, dataDetailTransaksi: null })}
        >
          {this.state.dataDetailTransaksi && (() => {
            const d = this.state.dataDetailTransaksi;
            const isMobile = this.state.isMobile;
            const fmt = val => 'Rp ' + (val ? val.toLocaleString('id-ID') : '0');
            const fmtTgl = val => val ? new Date(val).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) + ' ' + new Date(val).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' }) : '-';

            const renderRow = (label, value, key) => (
              <div key={key || label} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '7px 0', borderBottom: '1px solid #f5f5f5' }}>
                <Text type="secondary" style={{ fontSize: 12, flexShrink: 0 }}>{label}</Text>
                <Text style={{ fontSize: 12, fontWeight: 500, textAlign: 'right', wordBreak: 'break-word' }}>{value}</Text>
              </div>
            );

            const biayaFields = [
              ['Pokok PKB', d.pokok_pkb], ['Denda PKB', d.denda_pkb],
              ['Tunggakan Pokok PKB', d.tunggakan_pokok_pkb], ['Tunggakan Denda PKB', d.tunggakan_denda_pkb],
              ['Opsen Pokok PKB', d.opsen_pokok_pkb], ['Opsen Denda PKB', d.opsen_denda_pkb],
              ['Opsen Tunggakan Pokok PKB', d.opsen_tunggakan_pokok_pkb], ['Opsen Tunggakan Denda PKB', d.opsen_tunggakan_denda_pkb],
              ['Pokok BBNKB', d.pokok_bbnkb], ['Denda BBNKB', d.denda_bbnkb],
              ['Pokok SWDKLLJ', d.pokok_swdkllj], ['Denda SWDKLLJ', d.denda_swdkllj],
              ['Tunggakan Pokok SWDKLLJ', d.tunggakan_pokok_swdkllj], ['Tunggakan Denda SWDKLLJ', d.tunggakan_denda_swdkllj],
              ['TNKB STNK', d.pokok_admstnk], ['TNKB TNKB', d.pokok_admtnk],
            ];

            return (
              <div>
                {/* Header */}
                <div style={{
                  background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
                  padding: '18px 22px',
                  display: 'flex', alignItems: 'center', gap: 14,
                }}>
                  <div style={{
                    width: 46, height: 46, borderRadius: 12,
                    background: 'rgba(255,255,255,0.15)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                  }}>
                    <UserOutlined style={{ color: '#fff', fontSize: 20 }} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: '#fff', fontWeight: 700, fontSize: 16, lineHeight: 1.3 }}>
                      {d.pemilik ? d.pemilik.nama : '-'}
                    </div>
                    <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
                      {d.status_label || '-'}
                    </div>
                  </div>
                  {d.no_notice && (
                    <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', padding: '4px 12px' }}>
                      {d.no_notice}
                    </Tag>
                  )}
                </div>

                <div style={{ padding: isMobile ? '14px 16px' : '18px 22px', maxHeight: '65vh', overflowY: 'auto' }}>
                  {/* Section: Informasi Pemilik & Layanan */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <IdcardOutlined style={{ color: '#1e4d8a' }} />
                    <Text strong style={{ fontSize: 13, color: '#0f2847' }}>Informasi Pemilik & Layanan</Text>
                  </div>
                  {renderRow('NIK', d.pemilik ? d.pemilik.nik : '-')}
                  {renderRow('Alamat', d.pemilik ? d.pemilik.alamat : '-')}
                  {renderRow('Layanan', Array.isArray(d.layanan) && d.layanan.length > 0
                    ? d.layanan.map((it, i) => (
                      <Tag key={i} style={{ borderRadius: 12, marginLeft: 4, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontSize: 11 }}>{it}</Tag>
                    ))
                    : '-')}

                  <Divider style={{ margin: '12px 0' }} />

                  {/* Section: Proses Transaksi */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <TeamOutlined style={{ color: '#1e4d8a' }} />
                    <Text strong style={{ fontSize: 13, color: '#0f2847' }}>Proses Transaksi</Text>
                  </div>
                  {renderRow('Didaftarkan Oleh', d.dibuat_oleh ? d.dibuat_oleh.nama : '-')}
                  {renderRow('Tanggal Penetapan', fmtTgl(d.tgl_penetapan))}
                  {renderRow('Dibayarkan Oleh', d.dibayarkan_oleh ? d.dibayarkan_oleh.nama : '-')}
                  {renderRow('Tanggal Pembayaran', fmtTgl(d.paid_on))}
                  {renderRow('UPT Bayar', d.upt ? d.upt.nama : '-')}

                  <Divider style={{ margin: '12px 0' }} />

                  {/* Section: Rincian Biaya */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <DollarOutlined style={{ color: '#1e4d8a' }} />
                    <Text strong style={{ fontSize: 13, color: '#0f2847' }}>Rincian Biaya</Text>
                  </div>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                    columnGap: 24,
                  }}>
                    {biayaFields.map(([label, val], i) => renderRow(label, fmt(val), i))}
                  </div>

                  {/* Total */}
                  <div style={{
                    marginTop: 14,
                    padding: '12px 16px',
                    borderRadius: 10,
                    background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
                    border: '1px solid #d0dff5',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  }}>
                    <Text strong style={{ fontSize: 13, color: '#0f2847' }}>Total Pembayaran</Text>
                    <Text strong style={{ fontSize: 16, color: '#389e0d' }}>{fmt(d.total_bayar)}</Text>
                  </div>
                </div>
              </div>
            );
          })()}
        </Modal>

        <Modal
          title={
            <span>
              <IdcardOutlined style={{ marginRight: 8, color: '#1e4d8a' }} />
              {this.state.dataModal != null ? this.state.dataModal.judul : ""}
            </span>
          }
          centered
          visible={this.state.visibleModal}
          onCancel={() => this.setState({ visibleModal: false })}
          width={520}
          footer={[]}
          bodyStyle={{ padding: 0 }}
        >
          {this.state.dataModal != null && this.state.dataModal.konten && (() => {
            const p = this.state.dataModal.konten.value;
            const fmtTgl = val => val
              ? new Date(val).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) + ' ' + new Date(val).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' })
              : '-';
            const row = (label, value, key) => (
              <div key={key || label} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '7px 0', borderBottom: '1px solid #f5f5f5' }}>
                <Text type="secondary" style={{ fontSize: 12, flexShrink: 0 }}>{label}</Text>
                <Text style={{ fontSize: 12, fontWeight: 500, textAlign: 'right', wordBreak: 'break-word' }}>{value || '-'}</Text>
              </div>
            );
            return (
              <div>
                <div style={{
                  background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
                  padding: '18px 22px',
                  display: 'flex', alignItems: 'center', gap: 14,
                }}>
                  <div style={{
                    width: 46, height: 46, borderRadius: 12,
                    background: 'rgba(255,255,255,0.15)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                  }}>
                    <UserOutlined style={{ color: '#fff', fontSize: 20 }} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: '#fff', fontWeight: 700, fontSize: 16, lineHeight: 1.3 }}>
                      {p.nama_wp || '-'}
                    </div>
                    <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
                      Pemilik sejak {fmtTgl(p.created_at)}
                    </div>
                  </div>
                </div>
                <div style={{ padding: '16px 22px' }}>
                  {row('NIK', p.pemilik_nik)}
                  {row('Alamat', p.pemilik_alamat)}
                  {row('No HP', p.pemilik_no_hp)}

                  <Divider style={{ margin: '10px 0' }} />

                  {row('Nomor Polisi', p.nomor_polisi)}
                  {row('Merek', p.merek_nama)}
                  {row('Jenis', p.jenis_kendaraan_nama)}
                  {row('Tahun Buat', p.tahun_buat)}
                  {row('Nomor Rangka', p.nomor_rangka)}
                  {row('Nomor Mesin', p.nomor_mesin)}
                </div>
              </div>
            );
          })()}
          <Row justify="end" style={{ padding: '0 22px 16px' }}>
            <Col>
              <RoundedButton
                type="danger"
                key="btn-cancel"
                size="small"
                onClick={() => this.setState({ visibleModal: false })}
              >
                <CloseCircleOutlined /> Tutup
              </RoundedButton>
            </Col>
          </Row>
        </Modal>

        <Modal
          title={"Konfirmasi"}
          centered
          visible={this.state.modalKonfirmasi}
					closable={false}
          footer={[]}
          // onOk={() => this.setVisible(false)}
          // onCancel={() => this.setState({ modalKonfirmasi: false })}
          width={"40%"}
        >

          <Row>
            <Col span={24}>
              {(this.state.dataKendaraan != null && this.state.dataKendaraan.tunggakan.is_popup != undefined && this.state.dataKendaraan.tunggakan.is_popup &&
                <Row>
                  <Col span={24}>
                    {this.state.dataKendaraan.tunggakan.message}
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
          <Row justify="end" style={{ paddingTop: 30 }}>
            <Col style={{ padding: 5 }}>
              <RoundedButton
                type="primary"
                key="btn-cancel"
                size="small"
                onClick={() => {
                  this.setState({
                    modalKonfirmasi: false
                  }, () => {
                    this.formRef.current.setFieldsValue({
                      is_next: true,
                    });
                  })
                }}
              >
                <CheckCircleOutlined /> Lanjut
              </RoundedButton>
            </Col>
            {/* <Col style={{ padding: 5 }}>
              <Button
                type="danger"
                key="btn-cancel"
                size="small"
                onClick={() => this.setState({ modalKonfirmasi: false })}
              >
                <CloseCircleOutlined /> Tidak
              </Button>
            </Col> */}
          </Row>


        </Modal >

        <Modal
          title={"Kendaraan Diblokir"}
          centered
          visible={this.state.modalBlock}
          // onOk={() => this.setVisible(false)}
          onCancel={() => this.setState({ modalBlock: false, isOpenForm: false })}
          width={"40%"}
          footer={[]}
        >

          <Row>
            <Col span={24}>
              {(this.state.dataKendaraan != null &&
                <Row>
                  <Col span={24}>
                    <Alert
                      message="Kendaraan Diblokir"
                      description={this.state.dataKendaraan.alasan_blokir != undefined ? this.state.dataKendaraan.alasan_blokir : "Kendaraan dalam status Diblokir"}
                      type="error"
                      showIcon
                    />

                  </Col>
                </Row>
              )}
            </Col>
          </Row>
          <Row justify="end" style={{ paddingTop: 30 }}>
            <Col style={{ padding: 5 }}>
              <RoundedButton
                type="primary"
                key="btn-cancel"
                size="small"
                onClick={() => {
                  this.setState({
                    modalBlock: false,
                    isOpenForm: false
                  })
                }}
              >
                <CheckCircleOutlined /> Tutup
              </RoundedButton>
            </Col>
          </Row>
        </Modal >

        {this.renderModalBandingKendaraan()}

        <Modal
          title={"Masa Pajak Masih Aktif"}
          centered
          visible={this.state.modalMasaPajakAktif}
          onCancel={() => this.setState({ modalMasaPajakAktif: false })}
          width={"40%"}
          footer={[]}
        >
          <Row>
            <Col span={24}>
              <Alert
                message="Tidak Bisa Mendaftar Ulang"
                description={this.state.masaPajakAktifMsg || "Kendaraan ini sudah membayar pajak dan masa pajaknya masih aktif."}
                type="warning"
                showIcon
              />
            </Col>
          </Row>
          <Row justify="end" style={{ paddingTop: 30 }}>
            <Col style={{ padding: 5 }}>
              <RoundedButton
                type="primary"
                key="btn-tutup-masa-pajak-aktif"
                size="small"
                onClick={() => this.setState({ modalMasaPajakAktif: false })}
              >
                <CheckCircleOutlined /> Tutup
              </RoundedButton>
            </Col>
          </Row>
        </Modal>

        <Modal
          title={"Konfirmasi Nilai Pajak"}
          centered
          visible={this.state.modalNjkbKosong}
          closable={false}
          width={"40%"}
          footer={[]}
        >
          <Row>
            <Col span={24}>
              <Alert
                message="Nilai Pajak Rp 0"
                description="Nilai pajak (NJKB) untuk tipe dan tahun pembuatan kendaraan ini terhitung Rp 0. Periksa kembali data tipe/tahun, atau lanjutkan jika memang sudah benar."
                type="warning"
                showIcon
              />
            </Col>
          </Row>
          <Row justify="end" style={{ paddingTop: 30 }}>
            <Col style={{ padding: 5 }}>
              <RoundedButton
                type="danger"
                key="btn-batal-njkb-kosong"
                size="small"
                style={{ marginRight: 8 }}
                onClick={() => this.setState({ modalNjkbKosong: false, pendingSubmitValues: null })}
              >
                <CloseCircleOutlined /> Batal
              </RoundedButton>
            </Col>
            <Col style={{ padding: 5 }}>
              <RoundedButton
                type="primary"
                key="btn-lanjut-njkb-kosong"
                size="small"
                onClick={() => {
                  const values = this.state.pendingSubmitValues;
                  this.setState({ modalNjkbKosong: false, pendingSubmitValues: null }, () => {
                    this.postDataPemilik(values);
                  });
                }}
              >
                <CheckCircleOutlined /> Lanjutkan
              </RoundedButton>
            </Col>
          </Row>
        </Modal>

        <ErrorAlertModal
          visible={!!this.state.errTitle}
          title={this.state.errTitle}
          error={this.state.errMsg}
          onClose={() => this.setState({ errTitle: '', errMsg: '' })}
        />

        {/* Modal Batalkan Transaksi UPT Lain */}
        <Modal
          title={
            <span style={{ color: '#d4380d', fontWeight: 700, letterSpacing: 1 }}>
              ⚠ KENDARAAN SEDANG DALAM PROSES DI UPT LAIN
            </span>
          }
          open={this.state.modalBatalUptLain}
          centered
          footer={null}
          onCancel={() => this.setState({ modalBatalUptLain: false })}
          width={480}
        >
          {this.state.batalUptLainData && (() => {
            const d = this.state.batalUptLainData;
            return (
              <div>
                <p>
                  Kendaraan ini sedang dalam proses{' '}
                  <strong>{d.status_label}</strong> di UPT{' '}
                  <strong>{d.upt_nama}</strong>.
                </p>

                {d.status === 3 ? (
                  <>
                    <Alert
                      type="error"
                      showIcon
                      message="Tidak Dapat Dibatalkan"
                      description="Tagihan ini sudah berstatus Pembayaran dan tidak dapat dibatalkan."
                      style={{ marginBottom: 16 }}
                    />
                    <Row justify="end">
                      <Col>
                        <RoundedButton type="primary" onClick={() => this.setState({ modalBatalUptLain: false })}>
                          MENGERTI
                        </RoundedButton>
                      </Col>
                    </Row>
                  </>
                ) : d.dapat_batalkan ? (
                  <>
                    <Alert
                      type="warning"
                      showIcon
                      message="Pembatalan Lintas UPT"
                      description="Anda memiliki wewenang untuk membatalkan pendaftaran ini. Pilih alasan pembatalan terlebih dahulu."
                      style={{ marginBottom: 12 }}
                    />
                    <div style={{ marginBottom: 8 }}>
                      <label style={{ fontWeight: 600, display: 'block', marginBottom: 4 }}>
                        Alasan Pembatalan <span style={{ color: 'red' }}>*</span>
                      </label>
                      <Select
                        style={{ width: '100%' }}
                        placeholder="Pilih alasan..."
                        value={this.state.batalAlasan || undefined}
                        onChange={(val) => this.setState({ batalAlasan: val })}
                        options={[
                          { value: 'SALAH_UPT',        label: 'Pendaftaran di UPT yang salah' },
                          { value: 'PERMINTAAN_WP',    label: 'Permintaan Wajib Pajak' },
                          { value: 'DATA_TIDAK_VALID', label: 'Data tidak valid / perlu diperbaiki' },
                          { value: 'LAINNYA',          label: 'Lainnya' },
                        ]}
                      />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={{ fontWeight: 600, display: 'block', marginBottom: 4 }}>
                        Keterangan Tambahan
                      </label>
                      <Input.TextArea
                        rows={2}
                        placeholder="Opsional..."
                        value={this.state.batalKeterangan}
                        onChange={(e) => this.setState({ batalKeterangan: e.target.value })}
                      />
                    </div>
                    <Row justify="end" gutter={8}>
                      <Col>
                        <RoundedButton
                          danger
                          loading={this.state.loadingBatalUptLain}
                          onClick={() => this.batalkanUptLain()}
                        >
                          Batalkan &amp; Daftarkan di Sini
                        </RoundedButton>
                      </Col>
                      <Col>
                        <RoundedButton onClick={() => this.setState({ modalBatalUptLain: false })}>
                          Tutup
                        </RoundedButton>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Alert
                      type="info"
                      showIcon
                      message="Tidak Berwenang"
                      description="Jabatan Anda tidak memiliki izin untuk membatalkan transaksi di UPT lain. Hubungi supervisor atau pejabat berwenang."
                      style={{ marginBottom: 16 }}
                    />
                    <Row justify="end">
                      <Col>
                        <RoundedButton type="primary" onClick={() => this.setState({ modalBatalUptLain: false })}>
                          MENGERTI
                        </RoundedButton>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            );
          })()}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = function (state) {
  return state.configReducers;
};

export default connect(mapStateToProps, {
  initHandler,
  setConfig,
  ajaxViewHandler,
  ajaxHandler,
})(FormPendaftaran);
